import { amazonV2Translations } from "./amazonV2Translations";

const generatedCustomerEnglishTranslations: Record<string, string> = {
  "Etiket oluşturma ve iptal": "Create and cancel labels",
  "Manuel krediden gönderi/iade etiketi oluşturur ve uygun etiketleri iptal eder.": "Creates outbound/return labels using manual credit and cancels eligible labels.",
  "Gönderi veya iade etiketi oluşturma": "Create an outbound or return label",
  "En fazla 250 sipariş kontrol edilir; etiketler 100 etiketlik PDF dosyalarına ayrılır.": "Up to 250 orders can be checked; labels are split into PDF files containing at most 100 labels.",
  "PDF dosyalarını indir": "Download PDF files",
  "etiketi PDF dosyaları olarak tekrar indirebilirsiniz.": "labels can be downloaded again as PDF files.",
  "Toplu etiket PDF dosyaları hazırlanıyor.": "Preparing bulk label PDF files.",
  "Etiketler oluşturuldu fakat PDF dosyalarının tamamı hazırlanamadı. Son toplu işlemden tekrar indirmeyi deneyin.": "Labels were created, but not all PDF files could be prepared. Retry the download from the last bulk operation.",
  "Takip ve gönderimi PlentyONE’a geri yaz": "Write tracking and shipment back to PlentyONE",
  "Çekilecek sipariş dönemi": "Order import period",
  "Kaynak mağaza": "Source store",
  "Kaynak kanal": "Source channel",
  "Tüm": "All",
  "kanalları": "channels",
  "Sipariş alma ve kargo takibini geri yazma": "Import orders and write back shipment tracking",
  "PlentyONE REST API ile siparişleri alın; KenPost'ta oluşturulan kargo takip bilgisini PlentyONE'a geri yazın.":
    "Import orders through the PlentyONE REST API and write shipment tracking created in KenPost back to PlentyONE.",
  "PlentyONE alan adındaki p ile başlayan sistem numarası (ör. p64513 için 64513).":
    "The system number from the PlentyONE domain (for example, enter 64513 for p64513).",
  "REST API erişimi olan PlentyONE kullanıcı adı.": "PlentyONE username with REST API access.",
  "PlentyONE REST API kullanıcısının şifresi.": "Password of the PlentyONE REST API user.",
  "API şifresi": "API password",
  "REST API kullanıcı adı": "REST API username",
  "REST API şifresi": "REST API password",
  "Sipariş okuma ve kargo yazma yetkileri": "Permissions to read orders and write shipments",
  "PlentyONE API kullanıcısının yetkilerini kontrol edin.": "Check the permissions of the PlentyONE API user.",
  "System-ID ve API kullanıcı bilgilerini girin.": "Enter the System ID and API user credentials.",
  "Mağaza oluşunca ilk sipariş senkronunu başlatın.": "Start the first order sync after the store has been created.",
  "PlentyONE mağazasını bağla": "Connect PlentyONE store",
  "Paket ve gönderim kaydı": "Package and shipment record",
  "Güncelleniyor": "Will be updated",
  "Güncelle": "Update",
  "Etiket bakiyesi yok": "No label credit",
  "Bonus etiket": "Bonus label",
  "Bonus etiketleri nasıl kullanırım?": "How do I use bonus labels?",
  "Bonus etiketler ilgili ürünün normal bakiyesine otomatik eklenir. Ayrı bir kod girmeniz veya ödeme yapmanız gerekmez; siparişten etiket oluşturduğunuzda uygun Kleinpaket, 2 kg, 5 kg ya da diğer ürün bakiyesinden otomatik kullanılır.":
    "Bonus labels are automatically added to the regular balance for the corresponding product. You do not need to enter a separate code or make a payment; when you create a label for an order, the matching Kleinpaket, 2 kg, 5 kg, or other product balance is used automatically.",
  "etiket": "label",
  "adres": "Address",
  "adet": "piece",
  "iade": "Return",
  "Kalan etiket": "Remaining labels",
  "Diğer ürünler": "More products",
  "Etiket kırılımı": "Label division",
  "Kartta ilk 3 ürün gösterilir; tüm kırılım burada.": "The first 3 products are displayed on the map; Here you can see the complete breakdown.",
  "Ürün bazlı bakiye yok.": "No product-related credit available.",
  "Veri alınamadı.": "The data could not be loaded.",
  "Telefon numarası zorunludur.": "The phone number is required.",
  "Müşteri seçimini temizle": "Cancel customer selection",
  "Kontrol paneli verisi alınamadı.": "The dashboard data could not be loaded.",
  "Mağaza, sipariş, etiket ve gönderi durumunu tek ekranda takip edin.": "Keep an eye on shops, orders, labels and shipments on one page.",
  "Sipariş için yeni etiket": "New label for an order",
  "Bağlantıları ve senkronu yönet": "Manage connections and sync",
  "Bakiye ve fiyatları kontrol et": "Check balance and prices",
  "Tracking ve etiket çıktıları": "Tracking and label files",
  "Bugünkü çıkış": "Today's shipping",
  "Haftalık": "Last 7 days",
  "Son 7 gün": "last 7 days",
  "Son 3 ay": "Last 3 months",
  "Tüm tarihler": "All dates",
  "Sipariş gösterim aralığı": "Order display period",
  "Toplam etiket": "Labels in total",
  "Kullanılan": "Used",
  "Kullanıldı": "Used",
  "Açık sipariş": "Open orders",
  "Teslim edilen": "Delivered",
  "Teslim sinyali": "surrender signal",
  "Aktif taşıma": "Active transport",
  "Yolda paket": "On the way",
  "İade paket": "Returns",
  "Sorunlu paket": "Problematic shipments",
  "Müdahale gerekebilir": "Testing required",
  "Operasyon özeti": "Operations Overview",
  "Bugün kritik uyarı görünmüyor.": "There are no critical warnings today.",
  "Kalan kullanılabilir": "Still available",
  "Kontrol et": "Check",
  "Stabil": "Stable",
  "Toplam:": "Total:",
  "· Kullanıldı:": "· Uses:",
  "· Void:": "· Canceled:",
  "TOPLAM ETIKET": "LABELS TOTAL",
  "KULLANILDI": "USED",
  "AÇIK SIPARIŞ": "OPEN ORDERS",
  "Hızlı işlemler": "Quick Actions",
  "En sık kullanılan müşteri akışları.": "The most commonly used customer actions.",
  "İADE PAKET": "RETURNS",
  "SORUNLU PAKET": "PROBLEMATIC SHIPMENTS",
  "Veriler güncelleniyor": "Data is updated",
  "Canlı veriler hazır": "Live data is available",
  "30.05.2026 KenPost Version 2 geçişi": "May 30, 2026 Switch to KenPost Version 2",
  "Müşteri, sipariş, gönderi, etiket stoğu ve sorun sinyallerini tek bakışta okuyun. Sayfa, son veriyi hızlı gösterir ve arka planda canlı sayılarla yenilenir.": "Get an overview of customers, orders, shipments, label inventory and problem signals at a glance. The page shows the latest status immediately and updates the numbers in the background.",
  "Son 30 gün gönderi": "Shipments from the last 30 days",
  "Canlı operasyon temposu": "Current shipping volume",
  "Aktif müşteri": "Active customers",
  "Son 30 günde hareketli": "Active in the last 30 days",
  "Hazır etiket": "Available labels",
  "Temiz veya kontrol bekleyen stok": "Unused or yet to be inspected inventory",
  "Bugün dikkat edilecekler": "To check today",
  "Sorunlu paket, düşük bakiye ve bekleyen siparişleri hızlıca ayırır.": "Instantly identify problem shipments, low balances, and waiting orders.",
  "Bugünkü gönderi": "Today's broadcasts",
  "Etiket bekleyen sipariş": "Orders without a label",
  "Düşük bakiyeli müşteri": "Low balance customers",
  "Son 30 gün": "Last 30 days",
  "Düşük stok ürünü": "Low inventory product",
  "Takip olaylarını kapat": "Close tracking events",
  "DHL takip olayları": "DHL tracking events",
  "DHL takip sayfasını aç": "Open DHL shipment tracking",
  "Bu takip numarası için kaydedilmiş DHL event kaydı yok.": "There is no DHL event stored for this tracking number.",
  "Son kontrol": "Final test",
  "Son event": "Last event",
  "Ekip Üyeleri": "Team members",
  "Fiyatlandırma": "Pricing",
  "Satın Alımlar": "Purchases",
  "Müşteri bulunamadı.": "The customer was not found.",
  "DHL sağlık ekranı hazır": "The DHL shipping status view is ready",
  "Gönderi ve carrier check kayıtları geldikçe alarm, oran ve müdahale listeleri otomatik dolacak.": "Once shipping and carrier audit data is available, alerts, quotas and action lists are automatically populated.",
  "DHL gönderilerinizin teslim, yolda, geciken, sorunlu, iade ve tracking senkron durumunu tek operasyonda görün.": "Overview delivery, transport, delays, problems, returns and tracking synchronization of your DHL shipments in one place.",
  "Bugün operasyon sağlığı": "Current operating status",
  "Çıkan kargo": "Shipments sent",
  "30 günlük DHL etiketi": "DHL labels from the last 30 days",
  "Teslim oranı": "Delivery rate",
  "İlk scan yok": "No first scan",
  "2 günü aşan kayıt": "Older than 2 days",
  "Gönderi akışı": "Shipment history",
  "Etiket oluşturulduktan teslim ya da sorun sinyaline kadar DHL operasyon hunisi.": "DHL process from the created label to delivery or a problem signal.",
  "Etiket oluşturuldu": "Label created",
  "İlk carrier scan": "First carrier scan",
  "İade / Sorunlu": "Return/problem",
  "Müdahale Gerekenler": "Need for action",
  "Günlük operasyon için ilk bakılması gereken DHL gönderileri.": "DHL shipments that should be checked first in day-to-day business.",
  "Takip yazım hatası": "Tracking transmission error",
  "İşaretlendi": "Marked",
  "İşaretle": "Mark",
  "Teslim denemesi başarısız": "Delivery attempt failed",
  "Operasyon alarmı": "Operation warning",
  "Carrier error, tracking yazımı veya etiket üretim hatası kontrol edilmeli.": "Carrier errors, tracking transmission or label creation must be checked.",
  "5/7 gün kuralına takılan gönderiler listelendi.": "Shipments outside the 5/7 day rule will be listed.",
  "Pazar yeri tracking senkronu izlenmeli": "Check tracking synchronization with the marketplace",
  "DHL ürün performansı": "DHL product performance",
  "Mağaza performansı": "Shop performance",
  "Sorun oranı": "Problem rate",
  "Mağaza yok": "No shop",
  "Platform performansı": "Platform performance",
  "Şehir / bölge gecikmeleri": "Delays by city/region",
  "Risk oranı": "Risk ratio",
  "Bu dönem için karşılaştırma verisi yok.": "No comparative data is available for this period.",
  "çıkan ·": "shipped ·",
  "sorun ·": "problematic ·",
  "DHL carrier check, tracking senkronu ve ilk scan kayıtları geldikçe bu liste otomatik önceliklenecek.": "Once carrier checks, tracking sync, and initial scans are in place, this list will be automatically prioritized.",
  "gün": "days",
  "PDF indir": "Download PDF",
  "SLA: 2 gün ilk scan · 5/7 gün risk": "SLA: first scan after 2 days · Risk after 5/7 days",
  "Sağlık skoru": "Status assessment",
  "Carrier check kapsamı": "Scope of carrier testing",
  "Kargo sağlığı alınamadı.": "Shipping status could not be loaded.",
  "Takip senkronu başlatıldı.": "Tracking sync has started.",
  "Takip senkronu başlatılamadı.": "Tracking sync could not start.",
  "DHL kayıtları geldikçe teslimat, gecikme ve exception sinyalleri bu ekranda dolacak.": "As soon as DHL data is available, deliveries, delays and exception signals appear here.",
  "0 teslim": "0 delivered",
  "0 kargo": "0 shipments",
  "0 gönderi": "0 shipments",
  "Takip senkron": "Tracking sync",
  "0/0 başarılı": "0/0 successful",
  "Yeni mağaza bağla": "Connect new shop",
  "Desteklenen pazar yerleri kompakt listede.": "Supported marketplaces in a compact overview.",
  "Sipariş alma ve takip numarası geri yazma": "Retrieve orders and report tracking numbers",
  "Sipariş çekme ve fulfillment takibi": "Retrieve orders and track fulfillment",
  "Billbee siparişlerini içe aktarın": "Import Billbee orders",
  "OTTO mağaza bağlantısı": "OTTO shop connection",
  "About You sipariş bağlantısı": "About You order connection",
  "Server link ve Shopify kaynak akışı": "Server connection and Shopify data source",
  "Browser JSON sipariş kaynağı": "Browser JSON as order source",
  "Güvenli eBay bağlantısı": "Secure eBay connection",
  "eBay bağlantı yetkisi sona erdi. Yeni siparişleri almak için bağlantıyı yenileyin.":
    "The eBay authorization has expired. Renew the connection to retrieve new orders.",
  "eBay bağlantısını yenile": "Renew eBay connection",
  "eBay bağlantısını yönet": "Manage eBay connection",
  "Yeniden bağlantı gerekli": "Reconnection required",
  "JTL sipariş bağlantısı": "JTL order connection",
  "WooCommerce mağazanızı bağlayın": "Connect WooCommerce shop",
  "Kaufland marketplace bağlantısı": "Kaufland marketplace connection",
  "OpenCart mağaza bağlantısı": "OpenCart store connection",
  "Desteklenen pazar yeri bulunamadı.": "No supported marketplace was found.",
  "bağlantısını yönet": "Manage connection",
  "Mağazalar sayfasına yönlendiriliyorsunuz.": "You will be redirected to the shop page.",
  "Tarayıcı otomatik pencereyi engelledi.": "The browser blocked the pop-up.",
  "Yetkilendirme linkini manuel açıp onaydan sonra bu pencereye dönün.": "Open the authorization link manually and return to this window after sharing.",
  "Etsy hesabı ve browser profiliyle sipariş kaynağını eşleştirin.": "Link the order source to the Etsy account and browser profile.",
  "Etsy hesabını kaydet": "Save Etsy account",
  "Siparişleri çek": "Retrieve orders",
  "Profil hatası": "Profile error",
  "Mağaza detayı": "Shop details",
  "Sıklık": "Frequency",
  "Sıradaki": "Next execution",
  "Mağazalar alınamadı.": "The shops could not be loaded.",
  "eBay siparişleri alınamadı.": "The eBay orders could not be loaded.",
  "JTL bağlantısı hazır.": "The JTL connection is ready.",
  "JTL bağlantısı kontrol edilemedi.": "The JTL connection could not be checked.",
  "JTL bağlantısı test edilemedi.": "The JTL connection could not be tested.",
  "JTL siparişleri alınamadı.": "The JTL orders could not be loaded.",
  "Mağaza durumu güncellenemedi.": "The shop status could not be updated.",
  "Bağlantı detayı yok": "No connection details",
  "Henüz yok": "Not yet available",
  "Pasifleştir": "Disable",
  "Aktifleştir": "Activate",
  "Aktif": "Active",
  "Siparişi olan mağazalar silinemez.": "Shops with orders cannot be deleted.",
  "Siparişi olan mağazalar silinemez. Önce siparişleri kontrol edin.": "Shops with orders cannot be deleted. Check the orders first.",
  "Mağaza silinsin mi?": "Delete shop?",
  "Bu işlem mağaza bağlantısını kapatır. Sipariş içeren mağazalar silinemez.": "This will disconnect the shop connection. Shops with orders cannot be deleted.",
  "Mağazayı sil": "Delete shop",
  "Mağaza silinemedi.": "The shop could not be deleted.",
  "Amazon mağaza adı gerekli.": "The Amazon store name is required.",
  "Amazon durumu alınamadı.": "Amazon status could not be loaded.",
  "Amazon bağlantısı başlatılamadı.": "The Amazon connection could not be started.",
  "Tamamlanacak aktif Amazon yetkilendirme işi bulunamadı.": "No open Amazon authorization was found.",
  "Amazon bağlantısı tamamlanamadı.": "The Amazon connection could not be completed.",
  "Kapatılacak Amazon mağazası bulunamadı.": "No Amazon store to disconnect was found.",
  "Amazon bağlantısı kapatılamadı.": "The Amazon connection could not be disconnected.",
  "Amazon ara servisine ulaşılamıyor.": "The Amazon connection service is not available.",
  "Amazon bağlantısı hazırlanıyor": "Amazon connection is being prepared",
  "Yetkilendirme linki server tarafında hazırlanıyor. Açılan sekme birazdan Amazon onay ekranına yönlenecek; lütfen bu ekranı kapatmayın.": "The authorization link is prepared on the server. The new tab redirects straight to the Amazon release; please don't close it.",
  "Amazon yetkilendirme penceresi açıldı. Onaydan sonra buradan tamamlayın.": "The Amazon authorization window has opened. Once approved, complete the connection here.",
  "Yetkilendirme bağlantısı hazır; aşağıdaki bağlantıdan açın.": "The authorization link is ready; open it using the link below.",
  "Amazon bağlantı işi başlatıldı, fakat yetkilendirme URL'i dönmedi.": "The Amazon connection started but no authorization URL was returned.",
  "Amazon bağlantısı tamamlandı.": "The Amazon connection has been completed.",
  "Amazon bağlantısı başarıyla tamamlandı. Mağazalar sayfasına yönlendiriliyorsunuz.": "The Amazon connection was completed successfully. You will be redirected to the shop page.",
  "Amazon bağlantısı aktif. Bu mağaza artık sipariş senkronu için hazır.": "The Amazon connection is active. This store is now ready for order syncing.",
  "Amazon bağlantısı gönderildi; durum bridge tarafında bekliyor.": "The Amazon connection has been submitted; Confirmation of the connection service is still pending.",
  "Amazon onayı bekleniyor": "Amazon approval pending",
  "Amazon penceresinde onayı tamamlayıp süre bitmeden bu ekrandan bağlantıyı tamamlayın.": "Confirm access in the Amazon window and complete the connection here before the deadline expires.",
  "Amazon yetkilendirme süresi doldu. Lütfen bağlantıyı yeniden başlatın.": "Amazon authorization has expired. Please restart the connection.",
  "Amazon yetkilendirme süresi doldu": "Amazon authorization expired",
  "Bu onay linki artık güvenli şekilde kullanılamaz. Yeni bir yetkilendirme bağlantısı başlatın.": "This sharing link is no longer safe to use. Start a new authorization.",
  "Yeni Amazon bağlantısı başlat": "Start a new Amazon connection",
  "Amazon bağlantısı kapatıldı.": "The Amazon connection was disconnected.",
  "Henüz Amazon mağazası oluşmadı.": "No Amazon shop has been created yet.",
  "Etsy mağaza adı gerekli.": "Etsy shop name is required.",
  "Etsy durumu alınamadı.": "Etsy status could not be loaded.",
  "Etsy bağlantısı başlatılamadı.": "The Etsy connection could not be started.",
  "Tamamlanacak aktif Etsy yetkilendirme işi bulunamadı.": "No open Etsy authorization was found.",
  "Etsy bağlantısı tamamlanamadı.": "The Etsy connection could not be completed.",
  "Kapatılacak Etsy mağazası bulunamadı.": "No Etsy shop to disconnect was found.",
  "Etsy bağlantısı kapatılamadı.": "The Etsy connection could not be disconnected.",
  "Etsy ara servisine ulaşılamıyor.": "The Etsy connection service is unavailable.",
  "Etsy bağlantısı hazırlanıyor": "Etsy connection is being prepared",
  "Yetkilendirme linki server tarafında hazırlanıyor. Açılan sekme birazdan Etsy onay ekranına yönlenecek; lütfen bu ekranı kapatmayın.": "The authorization link is prepared on the server. The new tab redirects straight to the Etsy share; please don't close it.",
  "Etsy yetkilendirme penceresi açıldı. Onaydan sonra buradan tamamlayın.": "The Etsy authorization window has opened. Once approved, complete the connection here.",
  "Etsy bağlantı işi başlatıldı, fakat yetkilendirme URL'i dönmedi.": "The Etsy connection started but no authorization URL was returned.",
  "Etsy bağlantısı tamamlandı.": "The Etsy connection has been completed.",
  "Etsy bağlantısı başarıyla tamamlandı. Mağazalar sayfasına yönlendiriliyorsunuz.": "The Etsy connection was completed successfully. You will be redirected to the shop page.",
  "Etsy bağlantısı aktif. Bu mağaza artık sipariş senkronu için hazır.": "The Etsy connection is active. This store is now ready for order syncing.",
  "Etsy bağlantısı gönderildi; durum bridge tarafında bekliyor.": "The Etsy connection has been submitted; Confirmation of the connection service is still pending.",
  "Etsy onayı bekleniyor": "Pending Etsy approval",
  "Etsy penceresinde onayı tamamlayıp süre bitmeden bu ekrandan bağlantıyı tamamlayın.": "Confirm access in the Etsy window and complete the connection here before the deadline.",
  "Etsy yetkilendirme süresi doldu. Lütfen bağlantıyı yeniden başlatın.": "Etsy authorization has expired. Please restart the connection.",
  "Etsy yetkilendirme süresi doldu": "Etsy authorization expired",
  "Yeni Etsy bağlantısı başlat": "Start a new Etsy connection",
  "Etsy bağlantısı kapatıldı.": "The Etsy connection has been disconnected.",
  "Henüz Etsy mağazası oluşmadı.": "No Etsy shop has been created yet.",
  "Amazon ile aynı Salestio bridge senaryosuyla Etsy hesabını ekler.": "Connects the Etsy account using the same Salestio connection flow as Amazon.",
  "Bağlantı kapatılınca bu mağaza için otomatik sipariş senkronu durur.": "Disconnecting will stop automatic order synchronization for this store.",
  "Yarım kalan bağlantı kapatılacak ve yeni mağaza bağlantısı için ekran temizlenecek.": "The incomplete connection is terminated and the view is reset for a new shop connection.",
  "Yeni mağaza bağlantısı için ekran temizlenecek.": "The view is reset for a new shop connection.",
  "Aktif hale gelmiş mağazalara dokunulmaz; sadece yarım kalmış yetkilendirme işi temizlenir.": "Active shops remain unchanged; only the incomplete authorization process is removed.",
  "Baştan başlat": "Restart",
  "Meşgul": "Busy",
  "Ulaşılamıyor": "Unreachable",
  "Bağlı": "Connected",
  "Yeni": "New",
  "Kalan süre": "Time remaining",
  "Süre doldu": "Expired",
  "Yetkilendirme penceresinde onayı tamamladıktan sonra bağlantıyı buradan tamamlayın.": "Complete the connection here after confirming the release in the authorization window.",
  "Bağlantı tamamla penceresini kapat": "Close window to complete connection",
  "Süre": "Duration",
  "Etsy hesabı kaydedildi.": "The Etsy account has been saved.",
  "Etsy hesabı kaydedilemedi.": "The Etsy account could not be saved.",
  "Önce Etsy hesabını kaydedin.": "First save the Etsy account.",
  "Etsy siparişleri çekilemedi.": "The Etsy orders could not be retrieved.",
  "Etsy bağlantısı kapatılsın mı?": "Disconnect from Etsy?",
  "Otomatik Etsy sipariş senkronu durur.": "Etsy automatic order syncing will stop.",
  "Bu bilgiler KenPost tarafında saklanır; server profili hazır olduğunda siparişler JSON kaynağından alınır.": "This information is stored in KenPost; once the server profile is ready, orders are fetched from the JSON source.",
  "Etsy kullanıcı adı / e-posta": "Etsy username/email",
  "Etsy şifre": "Etsy password",
  "JSON kaynağı": "JSON source",
  "Ulaşılıyor": "Reachable",
  "Kaynak çalışması": "Source status",
  "Kaynak sipariş": "Source orders",
  "Son KenPost sync": "Latest KenPost sync",
  "KenPost sipariş": "KenPost orders",
  "Profil hazır değil.": "The profile is not ready yet.",
  "Admin sayfa kontrolü": "Checking the admin page",
  "Senkron logları alınamadı.": "The sync logs could not be loaded.",
  "Senkron logları yükleniyor": "Sync logs are loading",
  "Senkron logları": "Sync protocols",
  "Mağaza senkron geçmişi": "Store sync history",
  "Son durum": "Latest status",
  "Toplam log": "Total protocols",
  "Pasif mağazalar otomatik kontrolde denenmez.": "Inactive shops are skipped during the automatic check.",
  "Kapalı": "Disabled",
  "Log kayıtları": "Log entries",
  "Henüz senkron logu yok.": "No sync logs yet.",
  "Tür": "Type",
  "Sonuç": "Result",
  "Admin kullanıcı adı": "Admin username",
  "Admin şifre": "Admin password",
  "Mağaza oluşturulamadı.": "The shop could not be created.",
  "Platform Bağlantısı": "Platform connection",
  "Önerilen yöntem; client bilgileriyle çalışır.": "Recommended method; uses the client credentials.",
  "IP / DB Bağlantısı": "IP/database connection",
  "Özel JTL kurulumları için gelişmiş alanlar.": "Advanced fields for specific JTL installations.",
  "API anahtarı / Beyaz IP": "API key / shared IP",
  "OpenCart API kullanıcı adı ve anahtarıyla çalışır; gerekiyorsa sabit IP relay kullanılır.": "Uses OpenCart API username and key; If necessary, fixed IP forwarding is used.",
  "Admin erişimi": "Admin access",
  "Sipariş listesini admin panelinden okumak için kullanıcı adı ve şifre kullanır.": "Uses username and password to read the order list from the admin area.",
  "Bağlantı profili": "Connection profile",
  "Platforma göre gerekli alanlar ve çalışma biçimi ayrıştırıldı.": "Required fields and working methods are tailored to the platform.",
  "Kurulum akışı": "Setup flow",
  "Bu mağaza özel gönderici adresi kullanıyor": "This shop uses its own return address",
  "Bu mağaza genel profil adresini kullanıyor": "This shop uses the general profile address",
  "Mağaza gönderici adresi": "Shop return address",
  "Varsayılan olarak profilinizdeki genel gönderici adresi kullanılır; sadece bu mağaza farklı adresten gönderiyorsa özel adres tanımlayın.": "By default, your profile's general sender address is used. Only enter your own address if this shop ships from a different address.",
  "Mağaza özel adresi": "Own shop address",
  "Varsayılan genel adres": "General standard address",
  "Gönderici adı eksik": "Sender name is missing",
  "Özel adresi değiştir": "Change your own address",
  "Bu mağaza için farklı adres kullan": "Use a different address for this shop",
  "Özel gönderici adresini değiştir": "Change your own sender address",
  "Mağazaya özel gönderici adresi tanımla": "Enter your own sender address for the shop",
  "Mağaza detayı alınamadı.": "The shop details could not be loaded.",
  "Mağaza özel gönderici adresi aktif edildi.": "The shop's own sender address has been activated.",
  "Mağaza gönderici adresi kaydedilemedi.": "The shop's sender address could not be saved.",
  "Genel gönderici adresine dönülsün mü?": "Return to general sender address?",
  "Etiketler bundan sonra profilinizdeki genel gönderici adresini kullanır.": "In the future, labels will use the general sender address of your profile.",
  "Genel adrese dön": "Use general address",
  "Mağaza yeniden genel gönderici adresini kullanıyor.": "The shop uses the general sender address again.",
  "Genel gönderici adresine dönülemedi.": "The general sender address could not be restored.",
  "Seçilen mağaza gönderici adresi aktif edildi.": "The selected shop sender address has been activated.",
  "Mağaza gönderici adresi aktif edilemedi.": "The shop sender address could not be activated.",
  "Mağaza ayarları güncellendi.": "The shop settings have been updated.",
  "Mağaza güncellenemedi.": "The shop could not be updated.",
  "Sipariş senkronu tamamlanamadı.": "Order synchronization could not be completed.",
  "Bağlantı bilgisi yok": "No connection data",
  "Kayıtlı. Değiştirmek için yeni değer girin.": "Saved. To change, enter a new value.",
  "Onboarding bilgisi alınamadı.": "The setup data could not be loaded.",
  "İlk mağazanızı bağlayın.": "Connect your first shop.",
  "son 3 gün": "last 3 days",
  "son 1 gün": "last day",
  "son 7 gün": "last 7 days",
  "son 30 gün": "last 30 days",
  "son 3 ay": "last 3 months",
  "tüm dönem": "entire period",
  "Mağaza bilgilerini ekleyin; sipariş senkronu mağaza kaydından sonra yönetilir.": "Add the shop details; Order synchronization is managed after the store is saved.",
  "Platform bağlantı bilgisi": "Platform access data",
  "Mağaza adını girin.": "Enter the shop name.",
  "Mağazayı oluşturup ilk senkronu başlatın.": "Create the store and start the first sync.",
  "İsteğe bağlı": "Optional",
  "Afterbuy XML arayüzüyle siparişlerinizi alın ve oluşturulan takip numaralarını Afterbuy'a geri yazın.": "Retrieve orders via the Afterbuy XML interface and transfer created tracking numbers back to Afterbuy.",
  "Afterbuy hesabında görünen kullanıcı/hesap adı.": "The user or account name displayed in Afterbuy.",
  "KenPost için oluşturulan XML-Schnittstelle PartnerToken değeri.": "The XML interface PartnerToken created for KenPost.",
  "Afterbuy ekranında UserToken veya AccountToken olarak gösterilen değer.": "The value displayed in Afterbuy as UserToken or AccountToken.",
  "ör. bucomberlin": "e.g. B. Bucomberlin",
  "Afterbuy hesap adı": "Afterbuy account name",
  "Afterbuy'da XML-Schnittstelle erişimini açın.": "In Afterbuy, enable access to the XML interface.",
  "KenPost için verilen tokenları girin.": "Enter the tokens provided to KenPost.",
  "Bağlantı doğrulandıktan sonra ilk sipariş senkronunu başlatın.": "After a successful connection check, start the first order synchronization.",
  "Afterbuy mağazasını bağla": "Connect Afterbuy shop",
  "Afterbuy fatura otomasyonunu tetikle": "Trigger Afterbuy invoice automation",
  "Afterbuy yerel fatura akışı": "Native Afterbuy invoice workflow",
  "Takip numarası yazıldıktan sonra bu TAG mevcut TAG'ler korunarak Afterbuy siparişine eklenir. Faturayı ve PDF e-postasını Afterbuy'ın kendi iş akışı oluşturur; KenPost fatura numarası ile tarihini doğruladıktan sonra siparişi çalışma listesinden gizler. Amazon siparişleri hesap güvenliği için bu fatura e-posta tetikleyicisinden kesin olarak hariç tutulur.":
    "After the tracking number is written, this tag is added to the Afterbuy order without changing its existing tags. Afterbuy's native workflow creates the invoice and emails the PDF; KenPost hides the order from the work list only after verifying the invoice number and date. Amazon orders are completely excluded from this invoice-email trigger to protect the Amazon account.",
  "Tetik TAG'i": "Trigger tag",
  "Bu TAG, Afterbuy TAG Manager'da yalnız KenPost fatura iş akışı için oluşturulmalı ve Workflow Manager filtresinde aynı adla seçilmelidir.":
    "Create this tag in Afterbuy Tag Manager exclusively for the KenPost invoice workflow and select the exact same name in the Workflow Manager filter.",
  "Otomatik senkron": "Automatic sync",
  "Bu form mevcut KenPost müşteri panelindeki eski harici Shopify connector akışı içindir. App Store'daki KenPost Billing Bridge Shopify Admin içinde kurulum izinleri, App Bridge ve Shopify API ile çalışır.": "This form is intended for the existing external Shopify connection in the KenPost customer area. The KenPost Billing Bridge from the App Store uses install permissions, App Bridge, and the Shopify API within Shopify Admin.",
  "Örnek: mystore.myshopify.com": "Example: mystore.myshopify.com",
  "Mevcut müşteri connector erişim bilgisi. Orders ve fulfillment izinleri açık olmalı.": "Access data for the existing customer connection. Order and fulfillment permissions must be enabled.",
  "Connector erişim bilgisi": "Connection access data",
  "Bu form yalnızca mevcut KenPost müşteri connector'ı içindir": "This form is intended exclusively for the existing KenPost customer connection",
  "KenPost müşteri panelindeki harici connector için mağaza erişim bilgisini hazırlayın.": "Prepare the shop credentials for the external connection in the KenPost customer area.",
  "Domain ve erişim bilgisini bu forma girin.": "Enter your domain and access details in this form.",
  "Mağaza oluşunca sipariş senkronunu başlatın.": "After creating the store, start order synchronization.",
  "Shopify mağazasını bağla": "Connect Shopify store",
  "Billbee API bilgileriyle siparişlerinizi içe aktarın ve mağaza bazlı senkron yönetin.": "Import orders using Billbee API data and manage sync per store.",
  "Panelde görünecek Billbee bağlantı adı.": "The name of the Billbee connection displayed in the customer area.",
  "Billbee API anahtarı.": "Billbee API Key.",
  "Billbee API kullanıcı adı.": "Billbee API username.",
  "Billbee API şifresi.": "Billbee API password.",
  "Billbee bağlantı adı": "Billbee connection name",
  "Billbee API erişimini açın.": "Enable Billbee API access.",
  "API key ve kullanıcı bilgilerini girin.": "Enter API keys and user details.",
  "Mağazayı oluşturup siparişleri senkronlayın.": "Create the shop and synchronize the orders.",
  "Billbee mağazasını bağla": "Connect Billbee shop",
  "İçe aktarım": "Import",
  "About You bağlantısını API key ile ekleyin; sipariş çekme akışı mağaza ekranından çalışır.": "Add the About You connection with the API key; Orders are accessed via the shop view.",
  "About You adı": "About You Name",
  "API erişim bilgisini hazırlayın.": "Prepare the API credentials.",
  "Bağlantı adı ve API key bilgisini girin.": "Enter connection name and API key.",
  "Mağazayı oluşturun.": "Create the shop.",
  "About You mağazasını bağla": "Connect About You Shop",
  "Senkron": "Synchronization",
  "OTTO Partner Connect client bilgileriyle mağaza bağlantısını oluşturun.": "Create the shop connection with the client data from OTTO Partner Connect.",
  "Müşterinin göreceği OTTO mağaza adı.": "The OTTO shop name that is displayed to the customer.",
  "OTTO mağaza adı": "OTTO shop name",
  "OTTO Partner Connect hesabında client bilgilerini açın.": "Open the client data in the OTTO Partner Connect account.",
  "Client ID ve Secret alanlarını doldurun.": "Fill in Client ID and Client Secret.",
  "Mağazayı oluşturup senkronu çalıştırın.": "Create the store and start syncing.",
  "OTTO mağazasını bağla": "Connect OTTO shop",
  "Sipariş API": "Order API",
  "JTL için platform bağlantısı önceliklidir; IP/DB modu yalnızca özel kurulumlarda kullanılır.": "Platform connection is recommended for JTL; IP/database mode is only intended for special installations.",
  "JTL bağlantı URL'i. Örnek: https://shop.example.com": "JTL connection URL. Example: https://shop.example.com",
  "JTL platform bağlantısı Client ID.": "JTL platform connection client ID.",
  "JTL platform bağlantısı Client Secret.": "JTL platform connection client secret.",
  "Yalnızca IP/DB kurulumunda gerekli.": "Only required for an IP/database installation.",
  "JTL veritabanı adı.": "JTL database name.",
  "Veritabanı kullanıcısı.": "Database user.",
  "Veritabanı şifresi.": "Database password.",
  "Önce Platform Bağlantısı modunu deneyin.": "First use platform connection mode.",
  "Özel kurulum gerekiyorsa IP/DB modunu seçin.": "For a special installation, select IP/Database mode.",
  "Mağaza oluşunca bağlantıyı test edin.": "After creating the store, test the connection.",
  "JTL mağazasını bağla": "Connect JTL shop",
  "JTL senkron": "JTL synchronization",
  "Panel bağlantısı": "Panel connection",
  "JTL bağlantı modu": "JTL connection mode",
  "WooCommerce REST API anahtarlarıyla mağazanızı bağlayın.": "Connect your store with WooCommerce REST API keys.",
  "WooCommerce REST API anahtarlarını oluşturun.": "Create the WooCommerce REST API keys.",
  "URL ve anahtarları girin.": "Enter URL and key.",
  "Mağazayı oluşturup siparişleri çekin.": "Create the shop and retrieve the orders.",
  "WooCommerce mağazasını bağla": "Connect WooCommerce shop",
  "Yalnızca seçili ülkenin siparişlerini getir": "Retrieve orders only from the selected country",
  "Kapalıyken WooCommerce mağazasındaki tüm ülkelerin siparişleri alınır.":
    "When disabled, orders from all countries in the WooCommerce store are retrieved.",
  "Sipariş ülkesi": "Order country",
  "Kaufland marketplace bağlantısı için client key ve secret bilgilerini girin.": "Enter client key and secret for the Kaufland marketplace connection.",
  "Kaufland API credentials alanından key alın.": "Retrieve the key in the Kaufland API Credentials section.",
  "Storefront değerini kontrol edin.": "Check the storefront value.",
  "Mağaza kaydını oluşturun.": "Create the shop listing.",
  "Kaufland mağazasını bağla": "Connect to the Kaufland shop",
  "OpenCart mağazanızı admin erişimi veya API anahtarı/beyaz IP yöntemiyle bağlayın.": "Connect your OpenCart store with shared IP via admin access or API key.",
  "API modu için mağaza URL'i de yeterlidir; admin modu için /admin adresini girin. Örnek: https://site.com/admin": "In API mode, the shop URL is sufficient; In admin mode, enter the /admin address. Example: https://site.com/admin",
  "API modunda OpenCart API kullanıcı adı; admin modunda admin kullanıcısı.": "In API mode the OpenCart API username, in admin mode the admin user.",
  "API modunda OpenCart API anahtarı; admin modunda admin şifresi.": "In API mode the OpenCart API key, in admin mode the admin password.",
  "API kullanıcı adı": "API username",
  "API anahtarı veya admin şifresi": "API key or admin password",
  "Mağaza/Admin URL": "Shop/Admin URL",
  "Mağaza / Admin URL": "Shop/Admin URL",
  "API kullanıcı adı veya admin kullanıcı": "API username or admin user",
  "API anahtarı veya admin şifre": "API key or admin password",
  "Önce API anahtarı / beyaz IP modunu deneyin.": "First, use API key/shared IP mode.",
  "OpenCart API kullanıcısı ve anahtarı girin.": "Enter OpenCart API Users and Keys.",
  "Sipariş listesi için admin erişimi gerekiyorsa admin moduna geçin.": "Switch to admin mode if the order list requires admin access.",
  "OpenCart mağazasını bağla": "Connect OpenCart shop",
  "OpenCart senkron": "OpenCart sync",
  "OpenCart bağlantı modu": "OpenCart connection mode",
  "Zurück zu den Geschäften": "Back to the shops",
  "Manuel": "Manually",
  "Panelden": "About the panel",
  "OPSIYONEL": "OPTIONAL",
  "Opsiyonel": "Optional",
  "Gerekli bilgiler": "Required information",
  "Platform bilgilerini doldurun.": "Enter the platform details.",
  "Afterbuy'a geri yazma": "Report back to Afterbuy",
  "Orders okuma izni": "Authorization to read orders",
  "Fulfillment geri yazma izni": "Authorization to write back fulfillments",
  "Varsa uygulama/client ID bilgisini ekleyin.": "Add the app/client ID if available.",
  "KenPost Billing Bridge runs inside Shopify Admin.": "KenPost Billing Bridge runs within Shopify Admin.",
  "The Shopify App Store app home uses installed app permissions, App Bridge session tokens, token exchange, and Shopify Admin API. This customer connector form is only for existing KenPost account integrations.": "The Shopify app home page uses installed app permissions, App Bridge session tokens, token exchanges, and the Shopify Admin API. This customer connection form is for existing KenPost account integrations only.",
  "Etsy hesap bilgileri": "Etsy account details",
  "Browser profili": "Browser profile",
  "Browser portu": "Browser port",
  "Kaynak durumu": "Source status",
  "Profil durumu": "Profile status",
  "Platform / IP": "Platform/IP",
  "Kurulum": "Facility",
  "KURULUM": "FACILITY",
  "Opsiyonel IP/DB bilgileri": "Optional IP/DB data",
  "MSSQL portu. Genellikle 1433.": "MSSQL port. Normally 1433.",
  "Vitrin": "Storefront",
  "VITRIN": "STOREFRONT",
  "Relay destekli": "Relay supported",
  "Gerekirse KenPost sabit IP whitelist": "Share fixed KenPost IP if necessary",
  "Genel gönderici adresi eksik. Etiket oluşturmak için profil gönderici adresini veya bu mağaza için özel adresi tamamlayın.": "The general sender address is missing. Complete the profile address or a custom address for this shop to create labels.",
  "Genel profil adresine dön": "Return to the general profile address",
  "Kaydettiğiniz adres yalnızca bu mağazada etiket oluştururken kullanılır.": "The saved address will only be used when creating the label for this shop.",
  "Bu mağazada özel adresi kullan": "Use your own address for this shop",
  "Formu boşalt": "Empty form",
  "Daha önce kaydedilen özel adresler": "Previously saved own addresses",
  "Aktif yap": "Activate",
  "JTL ağırlığına göre otomatik": "Automatically according to JTL weight",
  "Etiket ürünü seçili değil": "No label product selected",
  "Sipariş destek verileri alınamadı.": "The additional order data could not be loaded.",
  "Siparişler alınamadı.": "The orders could not be loaded.",
  "Sipariş arşivlensin mi?": "Archive order?",
  "Arşivlenmiş siparişler görünümünden tekrar geri alınabilir.": "The order can be restored in the archived orders view.",
  "Arşivle": "Archive",
  "Arşivlenmiş siparişler": "Archived orders",
  "Arşivlenecek siparişleri seçin.": "Select the orders to archive.",
  "Seçili siparişler arşivlensin mi?": "Archive the selected orders?",
  "Arşivlenmiş siparişler görünümünden tek tek geri alınabilir.": "They can be restored individually from the archived orders view.",
  "Seçilenleri arşivle": "Archive selected",
  "Seçili siparişler arşivlenemedi.": "The selected orders could not be archived.",
  "Sipariş arşivlenemedi.": "The order could not be archived.",
  "Sipariş arşivden geri alınamadı.": "The order could not be restored from the archive.",
  "Bu sipariş": "This order",
  "Gönderi iptal edilemedi.": "The shipment could not be canceled.",
  "Senkron için aktif mağaza bulunamadı.": "No active store was found for synchronization.",
  "Senkron tamamlanamadı.": "The synchronization could not be completed.",
  "Senkron başlatılamadı.": "The synchronization could not be started.",
  "Etiket oluşturmak için sipariş ve etiket ürünü gerekli.": "An order and a label product are required to create the label.",
  "Etiket oluşturulamadı.": "The label could not be created.",
  "Etiket oluşturmadan önce ürün, kredi ve kargo adresini kontrol edin.": "Before creating the label, check the product, balance and delivery address.",
  "Toplu etiket geçmişi alınamadı.": "The bulk label history could not be loaded.",
  "Toplu etiketler tek PDF olarak yeniden hazırlanıyor.": "The labels are being prepared again as one PDF file.",
  "Son toplu etiketler tek PDF olarak yeniden hazırlanıyor.": "The latest bulk labels are being prepared again as one PDF file.",
  "Geçmişteki etiketler tek PDF olarak yeniden hazırlanıyor.": "The previous labels are being prepared again as one PDF file.",
  "Etiketler tek PDF olarak hazırlanamadı.": "The labels could not be prepared as one PDF file.",
  "Etiketler oluşturuldu fakat tek PDF hazırlanamadı. Son toplu işlemden tekrar indirmeyi deneyin.":
    "The labels were created, but the combined PDF could not be prepared. Try downloading it again from the latest bulk operation.",
  "Seçili siparişlerin tüm etiketleri hazır olmadığı için eksik toplu PDF indirilmedi.":
    "Not all selected labels are ready, so an incomplete bulk PDF was not downloaded.",
  "Toplu etiket geçmişi": "Bulk label history",
  "Son toplu etiket PDF hazır": "The latest bulk label PDF is ready",
  "Tek PDF'i indir": "Download one PDF",
  "Tek PDF olarak indirilebilir": "Available as one PDF file",
  "Etiketler tek PDF olarak hazırlanıyor": "The labels are being prepared as one PDF file",
  "Etiketler oluşturuldu, liste ve toplu etiket geçmişi yenileniyor.":
    "The labels were created; the list and bulk label history are being refreshed.",
  "Siparişlerden oluşturulan etiketleri tek PDF olarak tekrar indirebilirsiniz.":
    "You can download labels created from orders again as one PDF file.",
  "Toplu etiket geçmişini kapat": "Close bulk label history",
  "Toplu etiket geçmişi yükleniyor": "Bulk label history is loading",
  "Henüz toplu etiket kaydı yok": "There is no bulk label record yet",
  "Siparişleri seçip toplu etiket oluşturduğunuzda PDF kayıtları burada görünür.":
    "PDF records will appear here after you select orders and create bulk labels.",
  "Toplu ZIP geçmişi alınamadı.": "The ZIP collection history could not be loaded.",
  "Toplu etiket ZIP yeniden indiriliyor.": "The collection ZIP file will be downloaded again.",
  "Son toplu etiket ZIP yeniden indiriliyor.": "The final collection ZIP file will be downloaded again.",
  "Bu arşivde indirilebilir gönderi bulunamadı.": "This archive does not contain any downloadable shows.",
  "Toplu etiket için sipariş seçin.": "Select orders for bulk label creation.",
  "İade/iptal veya mevcut etiketi olan siparişler toplu etiket işleminden çıkarıldı.": "Canceled or returned orders and orders with an existing label have been removed from bulk processing.",
  "Seçili siparişler bu sayfada bulunamadı. Lütfen siparişleri tekrar seçin.": "The selected orders were not found on this page. Please select it again.",
  "Toplu etiket kontrolü hazırlanamadı.": "The inspection of the collective labels could not be prepared.",
  "Toplu etiket için hazırlanmış sipariş bulunamadı.": "No orders prepared for bulk labels were found.",
  "Toplu etiket oluşturulamadı.": "The collective labels could not be created.",
  "Toplu etiket parçası tamamlanamadı.": "A bulk-label segment could not be completed.",
  "sipariş hazır. En fazla": "orders are ready. Up to",
  "sipariş tek toplu işlemde sıraya alınır.": "orders are queued per bulk operation.",
  "Aktif siparişler": "Active orders",
  "Ürün detayları": "Item details",
  "Son toplu etiket ZIP hazır": "The final collection ZIP file is ready",
  "gönderilik son toplu paketi tekrar indirebilirsiniz.": "shipments in the last collective package; You can download it again.",
  "Son ZIP'i indir": "Download final ZIP file",
  "Geçmişi aç": "Open history",
  "Aktif mağaza yok": "No active shop",
  "Tüm mağazalar senkronize ediliyor": "All shops are synchronized",
  "mağaza": "Store",
  "Tüm Billbee mağazaları": "All Billbee stores",
  "seçili": "selected",
  "sipariş seçildi": "Orders selected",
  "Toplu etiket kontrolü": "Checking the collective labels",
  "Filtreleri temizleyin, mağaza senkronu çalıştırın veya ilk mağazanızı bağlayın.": "Reset filters, sync a store or connect your first store.",
  "Seçili siparişlerde paket, kilo ve adres bilgisini kontrol edin; onaydan sonra etiketler sırayla oluşturulur.": "Check package, weight and address details of selected orders. After confirmation, the labels will be created one by one.",
  "Seçili sipariş": "Selected order",
  "Henüz ürün seçilmedi": "No product selected yet",
  "Kredi işlemi tamamlandı": "Credit processing is complete",
  "Seçili siparişlerin etiket işlemi tamamlandı.": "Label creation for the selected orders is complete.",
  "Seçili tüm siparişlerin etiketleri zaten oluşturuldu.": "Labels have already been created for all selected orders.",
  "Son toplu işlem sonucu": "Result of the last collective processing",
  "oluşturuldu,": "created,",
  "mevcut gönderi atlandı,": "existing programs skipped,",
  "hata.": "Error.",
  "Seçili ürünlerden en az birinde kredi yetersiz. Ürünleri değiştirin veya kredi tanımlayın.": "There is not enough credit for at least one of the selected products. Change products or top up credit.",
  "Toplu kontrol için satır kalmadı.": "There are no longer any entries for the collective check.",
  "Takip:": "Tracking:",
  "Satırı çıkar": "Remove entry",
  "Etiket ürünü seçin": "Select label product",
  "sipariş hazır. En fazla 100 sipariş tek toplu işlemde sıraya alınır.": "Orders are ready. A maximum of 100 orders are scheduled per collection process.",
  "Toplu etiketleri oluştur": "Create collective labels",
  "Toplu etiket oluşturuluyor": "Collective labels are created",
  "Ağırlık / Toplam": "Weight / Total",
  "Koli sayısı": "Package count",
  "koli için": "for packages",
  "kredi gerekiyor; kullanılabilir kredi": "credits required; available credits",
  "Gönderiler ekranından tekrar indirebilirsiniz.": "You can download it again from the Shipments page.",
  "Sipariş otomatik arşivlendi.": "The order was archived automatically.",
  "Her koli için ayrı etiket ve ayrı takip numarası oluşturulur. Etiketler tek PDF dosyası halinde indirilir.":
    "Each package receives its own label and tracking number. The labels are downloaded as one PDF file.",
  "PDF’yi yeniden oluştur": "Recreate PDF",
  "Yeni takip numarasıyla değiştir": "Replace with new tracking number",
  "Etiket PDF’si yeniden oluşturulsun mu?": "Recreate the label PDF?",
  "Bu işlem yeni etiket ürünü seçmez; aynı takip numarası ve mevcut etiket kaynağı kullanılır.":
    "This does not select a new label product; it keeps the same tracking number and label source.",
  "Yeni takip numarası gerekiyorsa gönderi menüsündeki ‘Yeni takip numarasıyla değiştir’ işlemini kullanın.":
    "If you need a new tracking number, use ‘Replace with new tracking number’ in the shipment menu.",
  "Yeni takip numaralı etiket oluşturulsun mu?": "Create a label with a new tracking number?",
  "DHL durumu işlem sırasında yeniden kontrol edilir; taşıyıcı hareketi bulunan etiket değiştirilemez.":
    "The DHL status is checked again during the operation; a label with carrier movement cannot be replaced.",
  "Eski etiket kredisi hesaba geri döner ve yeni etiket farklı bir kaynaktan oluşturulur.":
    "The old label credit returns to the account and the new label is created from a different source.",
  "Yeni takip numarası bağlı satış kanalına otomatik gönderilir.":
    "The new tracking number is sent automatically to the connected sales channel.",
  "Yeni takip numarası oluştur": "Create new tracking number",
  "Farklı takip numaralı yeni etiket oluştur": "Create a new label with a different tracking number",
  "Aynı takip numaralı etiket PDF/ZIP dosyaları yeniden oluşturuldu.":
    "The label PDF/ZIP files were recreated with the same tracking number.",
  "Yeni takip numaralı etiket oluşturulamadı.": "The label with a new tracking number could not be created.",
  "Ürün aralığı": "Product area",
  "Seçili etiket ürünü için kullanılabilir kredi yok.": "There is no credit available for the selected label product.",
  "Alıcı, adres, posta kodu, şehir ve DE ülke kodu tamamlanmalı.": "Recipient, address, postal code, city and country code DE must be complete.",
  "Siparişlerden oluşturulan toplu etiket arşivlerini tekrar indirebilirsiniz.": "You can re-download bulk label archives created from orders.",
  "Henüz toplu ZIP kaydı yok": "No collective ZIP entry yet",
  "Siparişleri seçip toplu etiket oluşturduğunuzda arşiv kayıtları burada görünür.": "When you select orders and create bulk labels, the archives appear here.",
  "Birleşik PDF var": "Merged PDF available",
  "Birleşik PDF yok": "No merged PDF",
  "Sipariş toplu indirme": "Collective download for orders",
  "Tekrar indir": "Download again",
  "İşlem devam ediyor": "Process is running",
  "Senkronizasyon sürüyor": "Synchronization is in progress",
  "Senkronizasyon tamamlandı.": "Sync completed.",
  "Senkron penceresini kapat": "Close sync window",
  "Bu görünümde sadece arşive gönderilen siparişler gösterilir; geri alınan siparişler ana listeye döner.": "This view only shows archived orders; restored orders return to the main list.",
  "Billbee mağazası": "Billbee Shop",
  "Aktif listeye dön": "Return to active list",
  "Sayfadaki siparişleri seç": "Select orders on this page",
  "Lieferadresse · Fatura farklı": "Delivery address · Billing address different",
  "· Fatura farklı": "· Billing address different",
  "· fatura adresi farklı": "· Billing address different",
  "Alıcı adı DHL'nin 35 karakter sınırını aşıyor. Etiket oluşturmadan önce kısaltın.": "The recipient name exceeds the DHL limit of 35 characters. Shorten it before creating the label.",
  "Alıcı adı, baştaki bölümü korunarak DHL'nin 35 karakter sınırına otomatik kısaltılacak.": "The recipient name will be shortened automatically to DHL's 35-character limit while keeping its beginning.",
  "Şehir adı, baştaki bölümü korunarak posta koduyla birlikte DHL'nin 35 karakter sınırına otomatik kısaltılacak.": "The city name will be shortened automatically while keeping its beginning, so the postal code and city together fit DHL's 35-character limit.",
  "Sokak ve kapı numarası DHL'nin 35 karakter sınırını aşıyor. Etiket oluşturmadan önce kısaltın.": "Street and house number exceed the DHL limit of 35 characters. Shorten the information before creating the label.",
  "Adres eki DHL'nin 35 karakter sınırını aşıyor. Etiket oluşturmadan önce kısaltın.": "The address suffix exceeds the DHL limit of 35 characters. Shorten it before creating the label.",
  "Kayıt yok": "No records",
  "Sayfa başı": "Per page",
  "Sayfa başı order sayısı": "Orders per page",
  "Sipariş sayfaları": "Order pages",
  "Sonraki": "Next",
  "Toplu etiket kontrolünü kapat": "Close check of collective labels",
  "Düzenlenmesi gereken satır var": "Entries need to be corrected",
  "Satırlar hazır": "Entries are ready",
  "Zaten vardı": "Already exists",
  "Hata": "Error",
  "Etiketler oluşturuldu, liste ve ZIP geçmişi yenileniyor.": "The labels were created; List and ZIP history are updated.",
  "Etiket oluşturma penceresini kapat": "Close label creation window",
  "Toplu ZIP geçmişini kapat": "Close ZIP collection history",
  "Toplu ZIP geçmişi yükleniyor": "ZIP collection history is loading",
  "Geçmişteki toplu ZIP yeniden indiriliyor.": "The previous collective ZIP file will be downloaded again.",
  "Sipariş detayı alınamadı.": "The order details could not be loaded.",
  "Satılan ürünler": "Items sold",
  "Bu sipariş için ürün bilgisi bulunamadı.": "There is no item information for this order.",
  "Adres eki": "Address supplement",
  "Posta kodu ve şehir": "Zip code and city",
  "Alıcı adresi DHL'nin 5 satır sınırını aşıyor. Adres ekini veya alıcı satırlarını kısaltın.": "The recipient address exceeds the DHL limit of 5 lines. Shorten the address suffix or the recipient lines.",
  "Adres DHL etiket formatına uygun değil.": "The address does not correspond to the DHL label format.",
  "Etiket ürünü seçilmeli.": "A label product must be selected.",
  "Alıcı adı eksik.": "The recipient name is missing.",
  "Adres 1 eksik.": "The first address line is missing.",
  "Şehir eksik.": "The place is missing.",
  "Şimdilik sadece DE gönderileri destekleniyor.": "Currently only shipments within Germany are supported.",
  "Sipariş etiketi": "Order label",
  "Özel DHL adresi; gerekirse adresi normal teslimat adresiyle değiştirerek deneyin.": "Special DHL address; if necessary, use a normal shipping address instead.",
  "Ekip": "team",
  "Ekip üyeleri alınamadı.": "The team members could not be loaded.",
  "Ekip üyesi oluşturuldu.": "The team member has been created.",
  "Ekip üyesi oluşturulamadı.": "The team member could not be created.",
  "Ekip üyesi güncellendi.": "The team member has been updated.",
  "Ekip üyesi güncellenemedi.": "The team member could not be updated.",
  "Yeni ekip üyesi şifresi en az 6 karakter olmalı.": "The new team member's password must be at least 6 characters long.",
  "Şifre güncellendi.": "The password has been updated.",
  "Şifre güncellenemedi.": "The password could not be updated.",
  "Henüz girilmedi": "Not yet specified",
  "Profil bilgileri alınamadı.": "The profile data could not be loaded.",
  "Profil güncellendi.": "The profile has been updated.",
  "Profil güncellenemedi.": "The profile could not be updated.",
  "Yeni şifreler eşleşmiyor.": "The new passwords do not match.",
  "Fatura": "Invoice",
  "Giriş doğrulama tercihleri.": "Login confirmation settings.",
  "Girişte e-posta doğrulama kodu istenir.": "When registering, a confirmation code will be requested via email.",
  "Panelde görünen iletişim ve firma bilgileri.": "Contact and company details displayed in the customer area.",
  "Fatura adresi ve ülke bilgisi.": "Billing address and country.",
  "Gönderici": "Sender",
  "Gönderici bilgileri": "Sender details",
  "Etiketlerde kullanılacak gönderici adresi.": "From address used on the labels.",
  "Şifre güncelle": "Update password",
  "Mevcut şifrenizi doğrulayarak yeni şifre belirleyin.": "Confirm your current password and set a new one.",
  "Destek talebi gönderilemedi.": "The support request could not be sent.",
  "Destek raporu alınamadı.": "The support report could not be loaded.",
  "Eğitim videoları alınamadı.": "The training videos could not be loaded.",
  "Kategori": "Category",
  "Acil": "Urgent",
  "Konu": "Subject",
  "Mesaj": "Message",
  "KenPost ana sayfa": "KenPost homepage",
  "Türkçe": "Turkish",
  "English": "English",
  "Rapor listesi": "Report list",
  "Takip, sipariş, alıcı, şehir veya ürün ara": "Search by tracking number, order, recipient, city or product",
  "E-posta": "Email",
  "Ad": "First name",
  "Soyad": "Last name",
  "Hareket / durum": "Movement/Status",
  "Rapor önizleme": "Report preview",
  "Ay": "month",
  "İade": "Return",
  "3 ay": "3 months",
  "Taslak": "Draft",
  "Final": "Completed",
  "Normal purchase": "Normal purchase",
  "100 takibi senkronla": "Sync 100 tracking numbers",
  "Sadece iptaller": "Cancellations only",
  "Tüm takip senkronları": "All follow syncs",
  "Etiket / indirme": "Label / download",
  "Mağaza bağlantısı": "Store link",
  "Ekle": "Add",
  "Önceki": "Former",
  "Gönder": "Send",
  "Devre dışı": "disabled",
  "Gönderilerim": "My shows",
  "Etiketli gönderileri eski operasyon akışındaki gibi filtreleyin, indirin, yenileyin ve takip senkronlarını yönetin.": "Filter, load and update labeled shipments and manage their tracking sync.",
  "Gönderi detayı alınamadı.": "The shipment details could not be loaded.",
  "Tracking sync başlatılamadı.": "Tracking sync could not start.",
  "DHL takip aç": "Open DHL shipment tracking",
  "Takip linki yok": "No tracking link",
  "Son kontrol:": "Last test:",
  "· Son event:": "· Last event:",
  "Kaydedilmiş carrier event yok.": "No stored carrier event exists.",
  "Etiket indirmeleri": "Label Downloads",
  "PDF ve ZIP dosyaları tarayıcıda açılmadan indirilecek şekilde hazırlanır.": "PDF and ZIP files are prepared for direct download without opening them in the browser.",
  "Adobe PDF indir": "Download Adobe PDF",
  "Aç": "Open",
  "Seçili ZIP indir": "Download selection as ZIP",
  "Seçili tek PDF indir": "Download selection as one PDF",
  "Tüm filtrelenen gönderileri seç": "Select all filtered shipments",
  "Tümü seçiliyor": "Selecting all",
  "Etiket dosyası henüz hazır değil.": "The label file is not ready yet.",
  "Filtrelenen sonuçlarda indirilebilir aktif gönderi bulunamadı.": "No active shipment with a downloadable label was found in the filtered results.",
  "Filtrelenen gönderilerin tamamı seçilemedi.": "The filtered shipments could not all be selected.",
  "Seçili etiketler tek PDF dosyasında birleştiriliyor.": "The selected labels are being combined into one PDF file.",
  "Seçili etiketler tek PDF olarak hazırlanamadı.": "The selected labels could not be prepared as one PDF file.",
  "OLUŞTURULAN": "CREATED",
  "Oluşturulan": "Created",
  "Sorunlu": "Problematic",
  "KULLANILAN ÜRÜN": "PRODUCT USED",
  "Kullanılan ürün": "Product used",
  "Tüm türler": "All types",
  "Tüm platformlar": "All platforms",
  "Tüm carrier durumları": "All carrier statuses",
  "İade sürecinde": "In returns processing",
  "DHL durumu alınamadı": "DHL status not available",
  "Sıralama: en yeni": "Sorting: newest first",
  "Sıralama: etiket ürünü": "Sorting: label product",
  "Tüm taşıyıcılar": "All shipping service providers",
  "Tüm etiket ürünleri": "All label products",
  "Sayfadaki gönderileri seç": "Select shows on this page",
  "Seçimi temizle": "Deselect",
  "Filtreleri sıfırla": "Reset filter",
  "Faturalar alınamadı.": "The invoices could not be loaded.",
  "Manuel oluşturulan faturalarınız ve Shopify satın alma kayıtlarınız.": "Your manually created invoices and Shopify purchase records.",
  "Fatura CSV": "Invoice CSV",
  "Alım CSV": "Purchase CSV",
  "Fatura numarası, sipariş, mağaza veya etiket satın alma kaydı arayın.": "Search by invoice number, order, shop or label purchase.",
  "Fatura no, sipariş, mağaza veya ürün ara": "Search for invoice number, order, shop or product",
  "Tüm fatura durumları": "All invoice statuses",
  "Tüm Shopify alımları": "All Shopify purchases",
  "Shopify alım": "Shopify purchase",
  "Alım toplamı": "Purchase amount",
  "Faturalar yükleniyor": "Invoices are loading",
  "FATURA": "BILL",
  "ALIM TOPLAMI": "PURCHASE TOTAL",
  "FATURA NO": "INVOICE NO.",
  "FATURA ADET": "BILLS",
  "NET TUTAR": "NET AMOUNT",
  "Fatura no": "Invoice number",
  "Fatura adet": "Number of invoices",
  "Fatura detayı alınamadı.": "The invoice details could not be loaded.",
  "Fatura detayı": "Billing details",
  "Fatura güncellenemedi.": "The invoice could not be updated.",
  "Manuel yükleme": "Manual charging",
  "Düşüm": "Deduction",
  "Tamamlandı": "Completed",
  "Etiket bakiyeleri alınamadı.": "The label credits could not be loaded.",
  "Etiket bakiyeleri yükleniyor": "Label credits are loading",
  "Bakiye artışı": "Credit increase",
  "Bakiye düşümü": "Credit deduction",
  "Kullanılabilir": "Available",
  "Müsait": "Available",
  "Ürün bazlı bakiye": "Credit by product",
  "Satın alınan, yüklenen ve kalan etiket kredilerini ürün ve hareket bazında yönetin.": "Manage purchased, reloaded and remaining label credits by product and booking.",
  "Henüz etiket bakiyesi yok.": "No label credit available yet.",
  "Alınan": "Received",
  "Son alım": "Last purchase",
  "Tüm hareketler": "All bookings",
  "Satın alma/yükleme": "Purchase/Top-up",
  "Düşük": "Low",
  "Son satın alma ve manuel bakiye işlemleri.": "Recent purchases and manual credit postings.",
  "Ürün, not veya durum ara": "Search by product, note or status",
  "Süresi doldu": "Expired",
  "Atanmış etiketleri takip edin, tekil PDF indirin ve seçili ya da filtreli kayıtları ZIP/CSV olarak dışa aktarın.": "Track assigned labels, download individual PDFs, and export selected or filtered records as ZIP/CSV.",
  "Seçili ZIP": "Selection as ZIP",
  "İndirme geçmişi": "Download history",
  "Filtre ZIP": "Filtered ZIP file",
  "dosyasına yazıldı": "written to file",
  "Dosyayı indir": "Download file",
  "Admin etiket işlemi": "Admin label action",
  "Müşteriye atanmış fakat henüz kullanılmamış etiketleri güvenli biçimde iade edin veya temiz etiketlerle değiştirin.": "Securely return unused labels assigned to the customer or replace them with unused labels.",
  "Yeni etiketle değiştir": "Replace with new label",
  "SEÇILI ETIKET": "SELECTED LABELS",
  "Havuza iade": "Return to inventory",
  "Seçili etiket": "Selected label",
  "Daha önce indirilen": "Already downloaded",
  "Bu seçim yalnızca değiştirilebilir.": "This selection can only be replaced.",
  "Takip numarası, ürün, durum ve dış sistem kullanımına göre listeyi daraltın.": "Filter the list by tracking number, product, status and usage in external systems.",
  "Tüm dışa aktarımlar": "All export statuses",
  "Export edilmemiş": "Not exported",
  "Export edilmiş": "Exported",
  "Dış sistemde kullanılmamış": "Not used in external system",
  "Dış sistemde kullanılmış": "Used in external system",
  "Dış sistemde kullanıldı": "Used in external system",
  "Tüm ürünler": "All products",
  "50/sayfa": "50/page",
  "100/sayfa": "100/page",
  "250/sayfa": "250/page",
  "DIŞ SISTEM": "EXTERNAL SYSTEM",
  "İNDIR": "DOWNLOAD",
  "Etiket envanteri alınamadı.": "The label inventory could not be loaded.",
  "Export geçmişi alınamadı.": "The export history could not be loaded.",
  "Export için en az bir müsait etiket seçin.": "Select at least one available label to export.",
  "Bu seçim veya filtre için export edilecek etiket yok.": "There are no labels for export for this selection or filter.",
  "Devam ederseniz bu etiketler tekrar export dosyasına alınır ve export geçmişi güncellenir.": "If you continue, these labels will be re-exported and the export history will be updated.",
  "Envanter export oluşturulamadı.": "The inventory export could not be created.",
  "İşlem için en az bir atanmış ve kullanılmamış etiket seçin.": "Select at least one assigned, unused label for this action.",
  "Daha önce indirilen etiketler doğrudan havuza iade edilemez. Bu etiketleri yeni etiketlerle değiştirin.": "Labels that have already been downloaded cannot be returned directly to the inventory. Replace these labels with new ones.",
  "Seçili etiketler değiştirilsin mi?": "Replace selected labels?",
  "Seçili etiketler havuza iade edilsin mi?": "Return selected labels to inventory?",
  "Eski etiketler hatalı stok olarak ayrılacak.": "The previous labels are discarded as incorrect stock.",
  "Müşterinin toplam kullanılabilir etiketi ve satın alma geçmişi değişmeyecek.": "The total number of available labels and the customer's purchase history remain unchanged.",
  "Bu admin onayı, müşteriye son 3 ay içinde verilen fakat hiç indirilmemiş ve kullanılmamış etiketlerde bekleme kuralını aşar.": "This admin release overrides the waiting period for labels that were assigned to the customer in the last 3 months but were never downloaded or used.",
  "İndirilmiş, dış sistemde kullanılmış veya gerçek DHL hareketi bulunan etiketler yine kesinlikle engellenir.": "Labels that have been downloaded, used in external systems or have already been moved by DHL remain strictly blocked.",
  "Müşterinin kullanılabilir etiketi seçilen adet kadar azalacak.": "The customer's available labels are reduced by the selected number.",
  "Etiketleri değiştir": "Replace labels",
  "Onayla ve havuza iade et": "Confirm and return to inventory",
  "Admin destek modunda açık onay vererek son 3 aylık müşteri koruma süresini aştı.": "In admin support mode, the three-month customer protection period was expressly ignored.",
  "Etiket işlemi tamamlanamadı.": "The label campaign could not be completed.",
  "Takip no, dosya adı veya ürün ara": "Search by tracking number, file name or product",
  "Download geçmişi": "Download history",
  "Önceden oluşturulan CSV/ZIP export dosyaları.": "Previously created CSV/ZIP export files.",
  "Henüz export geçmişi yok.": "No export history yet.",
  "Etiket envanteri yükleniyor": "Label inventory is loading",
  "Sayfadaki müsait etiketleri seç": "Select available labels on this page",
  "İndir": "Download",
  "Bu filtreye uygun etiket yok.": "No labels match this filter.",
  "Dış sistem": "External system",
  "kayıttan": "of data sets",
  "gösteriliyor.": "are displayed.",
  "Aylık kullanım raporu": "Monthly usage report",
  "Ay bazında kullanılan etiket, gönderi ve açık sipariş görünümü.": "Monthly overview of labels used, shipments and open orders.",
  "Kargo sağlığı": "Shipping status",
  "Teslim, yolda, geciken, sorunlu ve müdahale gereken gönderiler.": "Delivered, in transit, delayed and problematic shipments as well as shipments requiring action.",
  "Aylık kullanım": "Monthly usage",
  "Kullanılan etiket, teslim, yolda, iade ve sorun görünümü.": "Overview of labels used, deliveries, ongoing shipments, returns and problems.",
  "Teslimat performansı": "Delivery performance",
  "Carrier ve platform bazında paket performansı.": "Parcel performance by shipping service provider and platform.",
  "Teslim, yolda, iade ve sorun sinyalleri.": "Signals for delivery, transport, returns and problems.",
  "Ürün/kg bazında mevcut bakiye ve tahmini bitiş.": "Current balance and predicted reach by product/weight.",
  "Sorunlu gönderiler": "Problematic shipments",
  "İade, carrier hatası ve takip senkronu sorunları.": "Returns, carrier errors, and tracking sync issues.",
  "Etiket bekleyen siparişler": "Orders without a label",
  "Açık kalan ve etiketi oluşturulmamış siparişler.": "Open orders for which a label has not yet been created.",
  "Satın alma raporu": "Purchase report",
  "Etiket alımları, tutar ve ürün kırılımı.": "Label purchases by amount and product.",
  "BAŞLANGIÇ TARIHI": "START DATE",
  "BITIŞ TARIHI": "END DATE",
  "Başlangıç tarihi": "Start date",
  "Bitiş tarihi": "End date",
  "ÜRÜN / KG": "PRODUCT / KG",
  "Ürün / kg": "Product / kg",
  "KULLANILAN ETIKET": "LABELS USED",
  "Kullanılan etiket": "Labels used",
  "TESLIM EDILEN": "DELIVERED",
  "SORUNLU": "PROBLEMATIC",
  "Affiliate bilgileri alınamadı.": "The partner program data could not be loaded.",
  "Affiliate programı açıldı.": "The affiliate program has been activated.",
  "Affiliate profili oluşturulamadı.": "The partner profile could not be created.",
  "Referans linki kopyalandı.": "The referral link has been copied.",
  "Referans ve kazanç": "Referrals & earnings",
  "Referans kontrolü": "Recommendation overview",
  "Müşteri, kod veya komisyon hareketi arayın.": "Search by customer, code or commission booking.",
  "Müşteri, e-posta, kod veya hareket ara": "Search by customer, email, code or booking",
  "Hesabınıza bağlı müşteri, kod veya komisyon hareketlerini filtreleyin.": "Filter customers, codes, and commission activity already linked to your account.",
  "Bağlı referanslarda müşteri, e-posta veya kod ara": "Search linked referrals by customer, email, or code",
  "Bu alan yalnızca hesabınıza zaten bağlı referansları filtreler; yeni bir müşteri bağlantısı oluşturmaz. Yeni kayıtlar referans linkinizle otomatik bağlanır. Mevcut bir müşteri hesabının sonradan bağlanması için destek ekibi yönetici panelindeki Affiliate hesapları ekranını kullanır.": "This field only filters referrals already linked to your account; it does not create a new customer link. New sign-ups are linked automatically through your referral link. To link an existing customer account later, support uses the Affiliate accounts page in the admin panel.",
  "Tüm komisyon durumları": "All commission statuses",
  "Bekleyen": "Pending",
  "Bekleyen (24 saat)": "Pending (24 hours)",
  "Onaylanan": "Approved",
  "Ödenen": "Paid",
  "Geçersiz": "Invalid",
  "Komisyonun kullanımı": "Using your commission",
  "Etiket ürünü ve pozitif tam adet seçin.": "Select a label product and enter a positive whole-number quantity.",
  "Kazanç etikete dönüştürülemedi.": "The earnings could not be converted into label credit.",
  "Etikete çevrilen": "Converted to labels",
  "Nakit ödenen": "Paid in cash",
  "Kazancınızı etiket bakiyesine çevirin": "Convert your earnings into label credit",
  "Onaylanan referans veya bonus kazancınızla gerçek etiket kredisi alın.": "Use approved referral or bonus earnings to receive real label credit.",
  "Referans veya bonus kazancınızı yönetici onayı beklemeden, mevcut tutarınızı aşmayacak şekilde etiket kredisine çevirin.": "Convert referral or bonus earnings into label credit immediately, without admin approval and without exceeding your available amount.",
  "Kazançlar 24 saat sonra otomatik onaylanır; müşteri isterse bekleme sırasında da yönetici onayı olmadan etiket kredisine çevirebilir.": "Earnings are approved automatically after 24 hours; during the waiting period, the customer can still convert them into label credit without admin approval.",
  "Kullanılabilir toplam": "Total available",
  "Doğrudan dönüşüm": "Instant conversion",
  "Onaylanan ve bekleyen kazançlarınız birlikte kullanılabilir. Seçtiğiniz etiketlerin toplamı mevcut kazancınızı aşamaz; kullanılan bekleyen hareketler işlem sırasında otomatik onaylanır.": "Approved and pending earnings can be used together. The selected labels cannot exceed your available earnings; pending entries used in the transaction are approved automatically.",
  "Etiket kullanımından oluşan kazanç 24 saatlik kontrol süresinin sonunda otomatik onaylanır. Onay beklerken de etiket bakiyesine çevrilebilir; yönetici işlemi gerekmez.": "Earnings from label usage are approved automatically after the 24-hour review period. They can also be converted into label credit while pending; no admin action is required.",
  "Bu ay satın alma": "Purchased this month",
  "Bu ay kullanılan": "Used this month",
  "Kullanılan (tüm zamanlar)": "Used (all time)",
  "Komisyona giren": "Commissionable",
  "Dönem içindeki uygun hareketler": "Eligible activity in the period",
  "Maksimum": "Maximum",
  "Toplam çevrilen": "Total converted",
  "/ adet · stok": "/ item · stock",
  "Kullanılacak kazanç": "Earnings to use",
  "KDV dahil etiket fiyatı üzerinden hesaplanır. Kalan kazanç hesabınızda kalır.": "Calculated using the VAT-inclusive label price. Any remaining earnings stay in your account.",
  "Bekleyen kazanç neden kullanılamıyor?": "Why can’t pending earnings be used?",
  "Bekleyen tutar yönetici kontrolündedir. Onaylandığında otomatik olarak kullanılabilir alana geçer. Yönetici isterse bekleyen tutarı doğrudan etiket bakiyenize de aktarabilir.": "Pending earnings are under admin review. Once approved, they automatically become available. An admin can also transfer pending earnings directly into your label credit.",
  "Etikete dönüşüm geçmişi": "Label conversion history",
  "Kazançtan etiket bakiyesine yapılan son işlemler.": "Recent conversions from earnings to label credit.",
  "Henüz etikete dönüştürülen kazanç yok.": "No earnings have been converted into label credit yet.",
  "Kullanılan kazanç": "Earnings used",
  "Komisyon tutarları etiket satın alma sepetinden ayrı yönetilir.": "Commission amounts are managed separately from the label purchase cart.",
  "Kullanımdan oluşmuştur ve yönetici kontrolü bekler. Bu tutar checkout sırasında otomatik indirim veya etiket kredisi olarak kullanılamaz.": "It was generated from usage and is awaiting admin review. This amount cannot be used automatically as a checkout discount or label credit.",
  "Kontrolü tamamlanmış, ödeme işlemine hazır komisyon tutarıdır.": "This commission has been reviewed and is ready for payment.",
  "Yönetici tarafından ödemesi tamamlanıp referansıyla kapatılmış komisyon tutarıdır.": "This commission has been paid and closed with its payment reference by an administrator.",
  "Henüz bağlı referans yok. Yeni kayıtlar referans linkiyle otomatik bağlanır; mevcut hesap bağlantısını destek ekibi yapar.": "There are no linked referrals yet. New sign-ups are linked automatically through the referral link; support links existing accounts.",
  "Tamamlanan siparişleri gizle": "Hide completed orders",
  "Siparişlerde gösterilecek ülkeler": "Countries shown in orders",
  "Boş: tüm ülkeler · Örnek: DE, AT": "Empty: all countries · Example: DE, AT",
  "İki harfli ülke kodlarını virgülle ayırın. Boş bırakırsanız tüm ülkeler görünür.": "Separate two-letter country codes with commas. Leave empty to show all countries.",
  "Sipariş ağırlığına göre otomatik": "Automatic by order weight",
  "Kaynak siparişte ağırlık bilgisi eksik. Yanlış DHL ürünü seçilmemesi için sistem otomatik seçim yapmadı; ürünü manuel doğrulayın.": "Weight information is missing from the source order. The system did not select a product automatically to avoid choosing the wrong DHL product; verify the product manually.",
  "KenPost ödeme hazırlanıyor": "Preparing KenPost payment",
  "Ödeme sayfanız hazırlanıyor…": "Your payment page is being prepared…",
  "etiket ·": "label ·",
  "XLSX dosyası okunamadı.": "The XLSX file could not be read.",
  "XLSX central directory okunamadı.": "The central XLSX directory could not be read.",
  "XLSX içinde çalışma sayfası bulunamadı.": "No worksheet was found in the XLSX file.",
  "Etiket bilgileri alınamadı.": "The label data could not be loaded.",
  "Adres önerisi uygulandı.": "The address suggestion was adopted.",
  "Adres bilgileri otomatik ayrıştırıldı.": "The address details were separated automatically.",
  "Alıcı adresini tek kutuya yapıştırın; alanlar otomatik doldurulur.":
    "Paste the recipient address into one box; the fields are filled automatically.",
  "Eski manuel alıcı forma aktarıldı.": "The last manual recipient has been included in the form.",
  "Varsayılan etiket seçimi kaydedildi.": "The default label selection has been saved.",
  "Varsayılan seçim kaydedilemedi.": "The default selection could not be saved.",
  "Import dosyası okunamadı.": "The import file could not be read.",
  "Import için geçerli satır bulunamadı.": "No valid rows were found for import.",
  "Toplu manuel etiket oluşturulamadı.": "The manual collection labels could not be created.",
  "Etiket yeniden oluşturulamadı.": "The label could not be recreated.",
  "Manuel etiket yeniden oluşturuldu.": "The manual label was created again.",
  "Manuel gönderi iptal edilsin mi?": "Cancel manual shipment?",
  "Etiket kredisi müşteri bakiyesine geri alınır ve gönderi iptal listesinde görünür.": "The label credit is credited to the customer account and the shipment appears in the cancellation list.",
  "Gönderi iptal edildi ve etiket kredisi hesabınıza geri döndü.": "The shipment has been canceled and the label credit has been credited to your account.",
  "Bazı etiketler oluşturulamadı.": "Some labels could not be created.",
  "Etiket ürünü zorunlu": "Label product required",
  "etiket hazır": "Labels ready",
  "etiket için yeterli kredi yok. Kullanılabilir kredi:": "Labels: insufficient funds. Available balance:",
  "PDF, ZIP veya gönderi detayına buradan hızlıca ulaşabilirsiniz.": "Here you can quickly access PDF, ZIP file or shipment details.",
  "Seçili ürün": "Selected product",
  "Adres kontrolü": "Address verification",
  "Tekrar kullanım": "Reuse",
  "eski manuel alıcı": "last manual recipients",
  "Aşağıdaki listeden seçip tekrar yazmadan forma aktarabilirsiniz.": "Select an entry from the list and add it to the form without re-entering it.",
  "Packstation veya Postfiliale adresleri manuel etiket için bloklanır. Bu adresler mağaza siparişi üzerinden veya doğru alıcı adresiyle işlenmeli.": "Packstation and post office addresses are blocked for manual labels. Process these addresses via a shop order or with a correct recipient address.",
  "Seçili üründe kullanılabilir kredi yok. Etiket oluşturmak için farklı ürün seçin veya kredi satın alın.": "No credit is available for the selected product. Choose another product or purchase credit.",
  "Son manuel alıcılar": "Last manual recipients",
  "Eski müşteriyi seçip adresi tekrar yazmadan yeni etiket oluşturabilirsiniz.": "Select a previous recipient and create a new label without re-entering the address.",
  "Henüz manuel oluşturulmuş alıcı bulunmuyor. İlk manuel etiketten sonra burada tekrar kullanım listesi oluşacak.": "No manually created recipient yet. After the first manual label, the reuse list appears here.",
  "Sipariş adresi kullanılacak": "Order address is used",
  "Adres tipi desteklenmiyor": "Address type is not supported",
  "Manuel adres hazır": "Manual address is ready",
  "Mağazadan gelen müşteri adresiyle etiket üretir.": "Creates the label with the customer address transmitted by the shop.",
  "Alıcı, adres, posta kodu ve şehir dolu olmalı.": "Recipient, address, zip code and city must be filled out.",
  "Etiket ürünleri alınamadı.": "The label products could not be loaded.",
  "Ödeme için sepete en az bir etiket ürünü ekleyin.": "To pay, add at least one label product to your shopping cart.",
  "Ödeme bağlantısı şu anda kullanılamıyor. Lütfen destek ekibine bildirin.":
    "The payment connection is currently unavailable. Please notify support.",
  "Ödeme için önce ürün miktarı girin veya Sepete ekle düğmesini kullanın.":
    "Enter a product quantity first or use the Add to cart button.",
  "Sepetteki miktarı mevcut stok sınırına düşürün.":
    "Reduce the quantity in the shopping cart to the available stock limit.",
  "Sepet checkout olarak açıldı. Ödeme tamamlanınca bakiye otomatik güncellenecek.": "The shopping cart has been opened for checkout. After completing the payment, the balance is automatically updated.",
  "Ödeme sayfası açıldı. Ödeme tamamlanınca bakiye otomatik güncellenecek.": "The payment page has been opened. After completing the payment, the balance is updated automatically.",
  "Tamamlanmayı bekleyen ödeme": "Pending payment",
  "Ödeme sekmesi açılmadıysa bağlantıyı buradan yeniden açabilirsiniz.": "If the payment tab did not open, you can reopen the link here.",
  "Ödeme sayfasını aç": "Open payment page",
  "Ödemeyi kontrol et": "Check payment",
  "Checkout oluşturulamadı.": "The checkout could not be created.",
  "Ödeme henüz tamamlanmamış görünüyor.": "The payment has apparently not yet been completed.",
  "Ödeme doğrulandı ve etiketler bakiyeye eklendi.": "The payment has been confirmed and the labels have been added to the balance.",
  "Ödeme kontrolü tamamlandı.": "Payment verification has been completed.",
  "Ödeme doğrulanamadı.": "The payment could not be confirmed.",
  "Etiket kredilerini checkout ile satın alın; ödeme tamamlanınca bakiyeniz otomatik güncellenir.": "Purchase label credit through checkout; After completing the payment, your balance will be automatically updated.",
  "Mevcut": "Present",
  "Satır brutto": "Gross per position",
  "adet.": "piece.",
  "Ürünlerden miktar girerek sepete satır ekleyin.": "Enter product quantities and add the items to the shopping cart.",
  "Ara toplam netto": "Subtotal net",
  "stok sınırını aşıyor.": "exceeds inventory.",
  "Ödemeye geç": "To checkout",
  "Şifreyi göster": "Show password",
  "Şifreyi gizle": "Hide password",
  "Süresi Bitmiş Etiketler": "Expired labels",
  "Genel bakış": "Overview",
  "Alt müşteri çalışma alanı": "Workspace for sub-customers",
  "Müşteri çalışma alanı": "Customer workspace",
  "Son sipariş, gönderi, etiket alımı ve fatura kayıtları burada görünecek": "Recent orders, shipments, label purchases and invoices are displayed here",
  "Raporlar hazır": "Reports are ready",
  "Yeni veri geldikçe dashboard otomatik dolacak": "The dashboard is automatically updated with new data",
  "İlk sipariş veya etiket oluşturulduğunda burada görünecek": "The first order or label will appear here",
  "Panel hazır": "Customer area is ready",
  "Mağaza, sipariş, etiket ve fatura hareketleri takip edilecek": "Shop, order, label and invoice activities are tracked here",
  "Yeni sürüm hazır": "New version available",
  "Sayfa eski önbellekten çalışıyor olabilir. Güncel etiket penceresi için sayfayı yenileyin.": "The site may still be using an older cache version. Refresh the page to load the latest version.",
  "sayfa": "Page",
  "Oluşturulma": "Creation",
  "Güncelleme": "Update",
  "Gönderim": "Transfer",
  "Sil": "Delete",
  "Pasif": "Inactive",
  "olarak müşteri panelindesiniz.": "You are in the customer panel.",
  "Takip geri yazma": "follow back write back",
  "Kaydet": "Save",
  "Sıfırla": "reset",
  "Profildeki genel gönderici adresi": "General sender address from the profile",
  "Senkron durumu": "Synchronous status",
  "Etikette SKU": "Label SKU",
  "Eski sistemdeki temel store ayarları ve platform credential bilgileri.": "Basic store settings and platform credential information in the old system.",
  "Kontrol": "Exam",
  "Başlangıç": "Beginning",
  "Etiket bakiyesi": "Label balance",
  "Mağazalara git": "Go to stores",
  "Plan ve etiket satın alma durumu.": "Plan and label purchase status.",
  "KenPost operasyon verisi": "KenPost operational data",
  "Final eşitleme": "final equalization",
  "Etiket paketleri": "sticker packs",
  "Etiket indirme": "Download labels",
  "Almanca etiket indirme ve çıktı alma adımları.": "Steps to download and print labels in German.",
  "Manuel etiket oluşturma": "Manual label creation",
  "Almanya içi manuel adres ve etiket oluşturma akışı.": "Process for manual addresses and labels within Germany.",
  "Mağaza bağlantıları": "Store links",
  "Shopify, eBay ve diğer pazar yerleri için bağlantı adımları.": "Connection steps for Shopify, eBay and other marketplaces.",
  "Toplu işlem": "Collective processing",
  "CSV/XLSX ile çoklu gönderi hazırlama ve sonuç kontrolü.": "Prepare multiple shipments via CSV/XLSX and check the results.",
  "Toplam gönderi": "total shipments",
  "Etiket bakiyeleri raporu": "Label balance report",
  "Ürün/kg bazında mevcut bakiye, son kullanım ve kritik stok.": "Current balance, last usage and critical inventory by product/weight.",
  "Toplam mevcut": "Total available",
  "Son 30 gün kullanım": "Usage in the last 30 days",
  "Kritik ürün": "Critical product",
  "Son kullanım": "Last use",
  "Tahmini kalan gün": "Estimated remaining days",
  "İade, carrier hatası, label ve takip senkronu sorunları.": "Returns, carrier errors, label and tracking sync issues.",
  "Sorunlu gönderi": "Problematic shipments",
  "Takip senkron hatası": "Tracking sync error",
  "Label üretim hatası": "Error creating label",
  "Sorun tipi": "Problem type",
  "Carrier mesajı": "Carrier message",
  "Rapor yükleniyor": "Report is loading",
  "Satın alınan etiket": "Purchased labels",
  "Toplam tutar": "Total amount",
  "Net tutar": "Net amount",
  "Adet": "number",
  "Not": "Note",
  "Yazdırılan": "Printed",
  "Takip başarılı": "Tracking successful",
  "Takip bekleyen": "pending follow up",
  "Carrier hata": "Carrier error",
  "disabled": "Disabled",
  "Alıcı": "Recipient",
  "Etiket ürünü": "Label product",
  "Etiket sağlayıcı": "Label provider",
  "Yazdırılma/Gönderim": "Printing/Sending",
  "Takip mesajı": "follow up message",
  "Takip zamanı": "tracking time",
  "Taşıyıcı": "Carrier",
  "DHL teslimat durumu": "DHL shipment status",
  "Gönderi bilgisi": "Shipment information",
  "Kaynak platform senkronu": "Source platform synchronization",
  "Takip no": "tracking number",
  "Gönderi tipi": "Shipment type",
  "Adres kaynağı": "Address source",
  "Shopify gönderim durumu": "Shopify shipping status",
  "Shopify mesajı": "Shopify message",
  "Ağırlık aralığı": "Weight range",
  "Gönderilere dön": "Back to shipments",
  "Takip senkronu": "tracking sync",
  "DHL event": "DHL event",
  "Gönderi detayı açılamadı": "Shipment details could not be opened",
  "Gönderi detayı yükleniyor": "Shipment detail loading",
  "Gönderi bulunamadı": "Shipment not found",
  "ZIP paket": "ZIP package",
  "Retoure / iade": "Return",
  "CSV dışa aktar": "Export CSV",
  "Ağırlık gr": "Weight (g)",
  "CSV indir": "Download CSV",
  "Excel indir": "Download Excel",
  "En eski tarih": "Oldest date",
  "manual": "Manually",
  "jtl": "JTL",
  "JTL_IP": "JTL (IP/database)",
  "The tracking result looked open, but this label is already consumed by a shipment in Kenpost. It is therefore kept as used. This label was already consumed in inventory, so only the carrier audit was updated.": "The tracking result appeared open, but this label had already been used by a KenPost shipment. It therefore remains marked as used. Since it has already been consumed from inventory, only the carrier check was updated.",
  "shipped": "Shipped",
  "paid": "Paid",
  "open": "Open",
  "success": "Successful",
  "pending": "Pending",
  "completed": "Completed",
  "active": "Active",
  "inactive": "Inactive",
  "available": "Available",
  "printed": "Printed",
  "failed": "Failed",
  "error": "Error",
  "cancelled": "Canceled",
  "canceled": "Canceled",
  "expired": "Expired",
  "disconnected": "Separate",
  "void": "Canceled"
};

const customerEnglishTranslationCorrections: Record<string, string> = {
  "Tekrar hoş geldin,": "Welcome back,",
  "Çıkış Yap": "Log out",
  "Etiket bekleyen": "Waiting for label",
  "Kargo Sağlığı": "Shipping health",
  "Senkronizasyonu başlat": "Start synchronization",
  "1 gün": "1 day",
  "3 gün": "3 days",
  "7 gün": "7 days",
  "30 gün": "30 days",
  "Açık": "Open",
  "Tüm mağazalarınızdaki siparişleri filtreleyin, senkronlayın, CSV alın ve etiket akışını aynı ekrandan yönetin.":
    "Filter and synchronize orders from all your stores, export CSV files and manage the label workflow from one screen.",
  "Toplu ZIP geçmişi": "Bulk ZIP history",
  "Toplam sipariş": "Total orders",
  "Sipariş kontrolü": "Order check",
  "Senkron aralığı sipariş çekme işlemini belirler; liste filtreleri ayrıca aşağıdan yönetilir.":
    "The synchronization range determines which orders are retrieved; list filters are managed separately below.",
  "Seçim": "Selection",
  "Mevcut kredi": "Available credit",
  "Aralık": "Range",
  "Tüm mağazaları senkronla": "Synchronize all stores",
  "Sipariş no, müşteri, e-posta, şehir ara": "Search by order number, customer, email or city",
  "Etiket bekliyor": "Waiting for label",
  "Gönderilenler": "Shipped",
  "Etiket var": "Label available",
  "Sadece gönderilmemiş": "Unshipped only",
  "Etiket bekleyen açık siparişler": "Open orders waiting for a label",
  "Toplam": "Total",
  "Güncelleniyor": "Updating",
  "Etiket bakiyesi yok": "No label balance",
  "adet": "quantity",
  "Kalan etiket": "Labels remaining",
  "Etiket kırılımı": "Label breakdown",
  "Kartta ilk 3 ürün gösterilir; tüm kırılım burada.":
    "The first 3 products are shown on the card; the full breakdown is available here.",
  "Ürün bazlı bakiye yok.": "No product-specific balance available.",
  "Veri alınamadı.": "The data could not be loaded.",
  "Müşteri seçimini temizle": "Clear customer selection",
  "Sipariş için yeni etiket": "New label for an order",
  "Bugünkü çıkış": "Today's shipments",
  "Haftalık": "Weekly",
  "Son 7 gün": "Last 7 days",
  "Toplam etiket": "Total labels",
  "Açık sipariş": "Open orders",
  "Teslim sinyali": "Delivery signal",
  "Aktif taşıma": "In transit",
  "Yolda paket": "In-transit shipments",
  "İade paket": "Return shipments",
  "Müdahale gerekebilir": "May need attention",
  "Operasyon özeti": "Operations overview",
  "Kalan kullanılabilir": "Remaining available",
  "· Kullanıldı:": "· Used:",
  "TOPLAM ETIKET": "TOTAL LABELS",
  "Hızlı işlemler": "Quick actions",
  "Veriler güncelleniyor": "Updating data",
  "30.05.2026 KenPost Version 2 geçişi": "30 May 2026 · Migration to KenPost Version 2",
  "Canlı operasyon temposu": "Current operational pace",
  "Aktif müşteri": "Active customers",
  "Bugün dikkat edilecekler": "Items to check today",
  "Bugünkü gönderi": "Today's shipments",
  "Son kontrol": "Last check",
  "Müdahale Gerekenler": "Needs attention",
  "Bugün operasyon sağlığı": "Today's operational health",
  "DHL gönderilerinizin teslim, yolda, geciken, sorunlu, iade ve tracking senkron durumunu tek operasyonda görün.":
    "View delivery, in-transit, delayed, problematic, return and tracking-sync statuses for your DHL shipments in one place.",
  "Operasyon alarmı": "Operational alert",
  "Mağaza performansı": "Store performance",
  "Mağaza yok": "No store",
  "Risk oranı": "Risk rate",
  "Sağlık skoru": "Health score",
  "Carrier check kapsamı": "Carrier-check coverage",
  "Yeni mağaza bağla": "Connect a new store",
  "Mağazalar sayfasına yönlendiriliyorsunuz.": "You will be redirected to the Stores page.",
  "Yetkilendirme linkini manuel açıp onaydan sonra bu pencereye dönün.":
    "Open the authorization link manually, approve access, then return to this window.",
  "Mağaza detayı": "Store details",
  "Pasifleştir": "Deactivate",
  "Amazon bağlantısı gönderildi; durum bridge tarafında bekliyor.":
    "The Amazon connection request was submitted and is awaiting confirmation from the bridge service.",
  "Yetkilendirme linki server tarafında hazırlanıyor. Açılan sekme birazdan Amazon onay ekranına yönlenecek; lütfen bu ekranı kapatmayın.":
    "The authorization link is being prepared on the server. The new tab will shortly open the Amazon approval screen; please do not close it.",
  "Bu onay linki artık güvenli şekilde kullanılamaz. Yeni bir yetkilendirme bağlantısı başlatın.":
    "This authorization link can no longer be used safely. Start a new authorization.",
  "Yetkilendirme linki server tarafında hazırlanıyor. Açılan sekme birazdan Etsy onay ekranına yönlenecek; lütfen bu ekranı kapatmayın.":
    "The authorization link is being prepared on the server. The new tab will shortly open the Etsy approval screen; please do not close it.",
  "Etsy bağlantısı gönderildi; durum bridge tarafında bekliyor.":
    "The Etsy connection request was submitted and is awaiting confirmation from the bridge service.",
  "Yetkilendirme penceresinde onayı tamamladıktan sonra bağlantıyı buradan tamamlayın.":
    "After approving access in the authorization window, complete the connection here.",
  "Senkron logları": "Sync logs",
  "Toplam log": "Total logs",
  "ör. bucomberlin": "e.g. bucomberlin",
  "Manuel yükleme": "Manual top-up",
  "Fatura detayı": "Invoice details",
  "Güncelleme": "Updated",
  "Gönderim": "Shipment",
  "Listeyi yenile": "Refresh list",
  "Takibi yenile": "Refresh tracking",
  "Takip geri yazma": "Tracking write-back",
  "Sıfırla": "Reset",
  "Senkron durumu": "Sync status",
  "Kontrol": "Check",
  "Başlangıç": "Start",
  "Final eşitleme": "Final sync",
  "Etiket paketleri": "Label packages",
  "Mağaza bağlantıları": "Store connections",
  "Toplu işlem": "Bulk processing",
  "Takip bekleyen": "Tracking pending",
  "Takip mesajı": "Tracking message",
  "Takip zamanı": "Tracking time",
  "Shopify gönderim durumu": "Shopify fulfillment status",
  "manual": "Manual",
  "disconnected": "Disconnected",
  "Etiket işlemi tamamlanamadı.": "The label operation could not be completed.",
  "Toplu manuel etiket oluşturulamadı.": "The bulk manual labels could not be created.",
  "etiket için yeterli kredi yok. Kullanılabilir kredi:": "Insufficient label credit. Available credit:",
  "olarak müşteri panelindesiniz.": "· customer view active.",
  "Kendi yazılımınızdan KenPost etiketi oluşturun ve sonuçları güvenle alın.": "Create KenPost labels from your own software and retrieve the results securely.",
  "API key oluştur": "Create API key",
  "anahtar": "keys",
  "Kopyala": "Copy",
  "Panoya kopyalandı.": "Copied to clipboard.",
  "API anahtarı oluşturuldu. Şimdi güvenli bir yere kaydedin.": "API key created. Save it in a secure place now.",
  "API anahtarı iptal edildi.": "API key revoked.",
  "Yeni API anahtarınız": "Your new API key",
  "Bu değer yalnızca bir kez gösterilir. Şimdi kopyalayıp parola kasanıza kaydedin.": "This value is shown only once. Copy it now and save it in your password manager.",
  "Anahtarı kopyala": "Copy key",
  "Kopyalandı": "Copied",
  "Güvenli erişim": "Secure access",
  "Anahtarlar yalnızca bir kez gösterilir ve KenPost'ta geri okunamaz. Her anahtarı ayrı yetki, IP ve son kullanma tarihiyle sınırlandırabilirsiniz.": "Keys are shown only once and cannot be retrieved from KenPost. You can restrict each key by scope, IP address and expiry date.",
  "Anahtarlar yalnızca bir kez gösterilir ve KenPost'ta geri okunamaz. Her anahtarı ayrı yetki, IP, son kullanma tarihi ve günlük etiket kotasıyla sınırlandırabilirsiniz.": "Keys are shown only once and cannot be retrieved from KenPost. You can restrict each key by scope, IP address, expiry date and daily label quota.",
  "Tekrarsız işlem": "Duplicate-safe requests",
  "Etiket oluştururken": "When creating a label",
  "zorunludur. Ağ hatasında aynı istek tekrar edilse bile ikinci kredi harcanmaz.": "is required. Retrying the same request after a network failure will not consume a second credit.",
  "Sunucudan sunucuya": "Server to server",
  "API yalnızca arka uç yazılımları içindir. Mağaza bağlama ve entegrasyon ayarları güvenlik nedeniyle müşteri panelinde kalır.": "The API is intended for backend software only. Store connections and integration settings remain in the customer panel for security.",
  "API anahtarları": "API keys",
  "Son kullanım ve istek sayıları burada izlenir.": "Last use and request counts are tracked here.",
  "Anahtarlar yükleniyor": "Loading keys",
  "Son kullanım:": "Last used:",
  "Son IP:": "Last IP:",
  "30 günlük istek:": "Requests in 30 days:",
  "Hız sınırı:": "Rate limit:",
  "Etiket kotası:": "Label quota:",
  "Oluşturma:": "Created:",
  "Son kullanma:": "Expires:",
  "IP kısıtı:": "IP restriction:",
  "İptal et": "Revoke",
  "Henüz API anahtarı yok.": "No API keys yet.",
  "İlk entegrasyonunuz için ayrı bir anahtar oluşturun.": "Create a separate key for your first integration.",
  "API dokümantasyonu": "API documentation",
  "Sürüm 1 · Temel adres:": "Version 1 · Base URL:",
  "OpenAPI indir": "Download OpenAPI",
  "Tüm isteklerde": "For every request, use the",
  "başlığı kullanılır. Anahtarı URL'ye, tarayıcı koduna veya loglara yazmayın.": "header. Never put the key in a URL, browser code or logs.",
  "Metot": "Method",
  "Uç": "Endpoint",
  "Yetki": "Scope",
  "Açıklama": "Description",
  "Hesap ve gönderici hazırlığı": "Account and sender readiness",
  "Desteklenen özellikler": "Supported features",
  "Etiket ürünleri": "Label products",
  "Kullanılabilir krediler": "Available credits",
  "Bağlı mağazalar (salt okunur)": "Connected stores (read only)",
  "Kredi harcamadan doğrulama": "Validation without spending credit",
  "Etiket oluşturma": "Create label",
  "API etiketlerini listeleme": "List API labels",
  "Etiket durumu ve takip no": "Label status and tracking number",
  "Etiket PDF'i": "Label PDF",
  "Etiket oluşturma örneği": "Label creation example",
  "cURL örneği kopyalandı.": "cURL example copied.",
  "Başarılı yanıt": "Successful response",
  "Standart hata": "Standard error",
  "Her etiket isteğinde sipariş ve paket için benzersiz bir anahtar gönderin. Aynı anahtar ve aynı gövde güvenle tekrar edilebilir.": "Send a unique key per order and package for every label request. The same key and identical body can be retried safely.",
  "Hız sınırı": "Rate limiting",
  "Katmanlı hız sınırı": "Layered rate limiting",
  "Anahtar, hesap ve etiket oluşturma limitlerinden biri aşılırsa": "If a key, account or label creation limit is exceeded, the API returns",
  "kadar bekleyin; otomatik tekrarlar için gecikmeyi kademeli artırın.": "before retrying; use progressive backoff for automatic retries.",
  "Aşıldığında": "When exceeded, the API returns",
  "döner.": ". Follow the",
  "başlığını izleyerek tekrar deneyin.": "header before retrying.",
  "Veri sınırı": "Data boundary",
  "Gönderici adresi paneldeki doğrulanmış profilden gelir. API, mağaza bağlantısı ekleyemez veya değiştiremez.": "The sender address comes from the verified panel profile. The API cannot add or change store connections.",
  "addresses ile iki adresi etiket bazında belirleyebilirsiniz. Bu alan gönderilmezse mevcut profil adresi kullanılır. API, hesap profilini veya mağaza bağlantılarını değiştirmez.": "Use addresses to choose both parties for each label. If omitted, the existing profile address is used. The API does not change the account profile or store connections.",
  "Yeni API key": "New API key",
  "Her uygulama veya sunucu için ayrı anahtar oluşturmanız önerilir.": "We recommend a separate key for each application or server.",
  "Anahtar adı": "Key name",
  "Örn. Depo yazılımı": "e.g. warehouse software",
  "Yetkiler": "Scopes",
  "Son kullanma tarihi (isteğe bağlı)": "Expiry date (optional)",
  "Dakikalık istek sınırı": "Requests per minute",
  "Günlük etiket sınırı": "Daily label limit",
  "Anahtar sınırı": "Key limit",
  "Ayarlanan değer / dakika": "Configured value / minute",
  "Etiket dakika sınırı": "Label rate limit",
  "Günlük etiket kotası": "Daily label quota",
  "Anahtar başına ayarlanır": "Configured per key",
  "Hesap güvenlik tavanı": "Account safety ceiling",
  "Birden çok anahtar kullanılsa bile hesap genelinde aşılmaz.": "The account-wide ceiling cannot be exceeded even with multiple keys.",
  "İzinli IP adresleri (isteğe bağlı)": "Allowed IP addresses (optional)",
  "Boş bırakırsanız tüm IP adresleri kullanılabilir. Sabit sunucu IP'lerini virgülle ayırın.": "Leave blank to allow all IP addresses. Separate fixed server IP addresses with commas.",
  "Vazgeç": "Cancel",
  "Anahtarı oluştur": "Create key",
  "Hesap bilgisi": "Account details",
  "Bakiyeler": "Balances",
  "Mağazalar": "Stores",
  "Adres doğrulama": "Address validation",
  "Etiket okuma": "Read labels",
  "API anahtarı yalnızca hesap sahibinin kendi oturumunda oluşturulabilir.": "An API key can only be created from the account owner's own session.",
  "API anahtarı yalnızca hesap sahibinin kendi oturumunda oluşturulabilir veya iptal edilebilir.": "API keys can only be created or revoked from the account owner's own session.",
  "Hesap ve gönderici hazırlık durumunu okur.": "Reads the account and sender readiness status.",
  "Kullanılabilir ürünleri ve ağırlıkları okur.": "Reads available products and weight ranges.",
  "Etiket kredilerini okur.": "Reads label credits.",
  "Bağlı mağazaları ve senkron durumunu salt okunur görüntüler.": "Reads connected stores and their synchronization status.",
  "Kredi harcamadan etiket isteğini kontrol eder.": "Validates a label request without spending credit.",
  "Manuel krediden yeni etiket oluşturur.": "Creates a new label from manual credit.",
  "API etiketlerini ve PDF dosyalarını okur.": "Reads API labels and PDF files.",
};

export const customerEnglishTranslations: Record<string, string> = {
  "Bu Amazon siparişi henüz gönderime uygun değil.": "This Amazon order is not ready to ship yet.",
  "Amazon V1 artık yeni sipariş almıyor. Amazon V2’ye bağlanın.": "Amazon V1 no longer imports new orders. Connect Amazon V2.",
  "Sipariş mağazası": "Order store",
  "Sipariş platformu": "Order platform",
  "Etiket satın alımlarında minimum ödeme tutarı KDV dahil 20 €’dur. Lütfen sepet tutarını artırın.": "The minimum order value for labels is €20 including VAT. Please increase your cart total.",
  "Minimum alışveriş: KDV dahil 20 €.": "Minimum order value: €20 including VAT.",
  "Resmi Shopify uygulamasını kurun": "Install the official Shopify app",
  "JTL Connect · veritabanı şifresi gerektirmez": "JTL Connect · no database password required",
  "Shopify mağazası bağla": "Connect Shopify store",
  "Yeni Shopify bağlantıları güvenli kurulum ve ücretlendirme için Shopify App Store üzerinden yapılır.": "New Shopify connections use the Shopify App Store for secure installation and billing.",
  "Manuel API anahtarı veya Shopify şifresi gerekmez.": "No manual API key or Shopify password is required.",
  "Shopify mağazanızda uygulamayı kurun, Shopify planını onaylayın ve ardından KenPost hesabınızı tek tıkla bağlayın.": "Install the app in your Shopify store, approve the Shopify plan and then link your KenPost account with one click.",
  "Shopify App Store'da aç": "Open in Shopify App Store",
  ...generatedCustomerEnglishTranslations,
  ...customerEnglishTranslationCorrections,
  ...amazonV2Translations.en,
};

export type CustomerEnglishTranslationPattern = {
  pattern: RegExp;
  replace: (match: RegExpMatchArray) => string;
};

export const customerEnglishTranslationPatterns: CustomerEnglishTranslationPattern[] = [
  {
    pattern: /^(\d+) etiket bakiyenize eklendi\. Kullanılan kazanç: (.+)\.$/,
    replace: (match) => `${match[1]} labels were added to your balance. Earnings used: ${match[2]}.`,
  },
  { pattern: /^(.+?) mağazası bağla$/, replace: (match) => `Connect ${match[1]} store` },
  { pattern: /^(.+?) sipariş detayını aç$/, replace: (match) => `Open order details for ${match[1]}` },
  { pattern: /^(.+?) gönderisini iptal et$/, replace: (match) => `Cancel shipment for ${match[1]}` },
  { pattern: /^(.+?) için etiket oluştur$/, replace: (match) => `Create label for ${match[1]}` },
  { pattern: /^(.+?) etiketi indir$/, replace: (match) => `Download label for ${match[1]}` },
  { pattern: /^(.+?) siparişini arşivden geri al$/, replace: (match) => `Restore order ${match[1]} from archive` },
  { pattern: /^(.+?) siparişini arşivle$/, replace: (match) => `Archive order ${match[1]}` },
  { pattern: /^(.+?) siparişini seç$/, replace: (match) => `Select order ${match[1]}` },
  { pattern: /^(.+?) gönderisini seç$/, replace: (match) => `Select shipment ${match[1]}` },
  { pattern: /^(\d{8,}) seç$/, replace: (match) => `Select ${match[1]}` },
  { pattern: /^([\d.,]+) items? ürün detayları$/, replace: (match) => `Product details for ${match[1]} items` },
  {
    pattern: /^(?=.* - Birim [^·]+ · Toplam [\d.,]+).+$/,
    replace: (match) =>
      match[0].replace(
        / - Birim ([^·]+?) · Toplam ([\d.,]+(?:\s*(?:€|£|\$|[A-Z]{3}))?)/g,
        " – Unit price $1 · Total $2",
      ),
  },
  { pattern: /^(.+?) miktarını azalt$/, replace: (match) => `Decrease quantity for ${match[1]}` },
  { pattern: /^(.+?) miktarını artır$/, replace: (match) => `Increase quantity for ${match[1]}` },
  { pattern: /^(.+? · )([\d.,]+) sipariş$/, replace: (match) => `${match[1]}${match[2]} orders` },
  { pattern: /^([\d.,]+) sipariş$/, replace: (match) => `${match[1]} orders` },
  {
    pattern: /^([\d.,]+) aktif mağazada sipariş senkronu çalışmış görünüyor\.$/,
    replace: (match) =>
      match[1] === "1" ? "Order sync has run for 1 active store." : `Order sync has run for ${match[1]} active stores.`,
  },
  { pattern: /^([\d.,]+) mağaza bağlı\.$/, replace: (match) => `${match[1]} ${match[1] === "1" ? "store" : "stores"} connected.` },
  { pattern: /^([\d.,]+) sipariş görünüyor\.$/, replace: (match) => `${match[1]} ${match[1] === "1" ? "order" : "orders"} shown.` },
  { pattern: /^([\d.,]+) kullanılabilir etiket\.$/, replace: (match) => `${match[1]} ${match[1] === "1" ? "label" : "labels"} available.` },
  {
    pattern: /^([\d.,]+) ürün için kalan etiket kredileri\.$/,
    replace: (match) => `Remaining label credit for ${match[1]} ${match[1] === "1" ? "product" : "products"}.`,
  },
  { pattern: /^([\d.,]+) (.+?) siparisi senkronlandi\.$/, replace: (match) => `${match[1]} ${match[2]} orders synchronized.` },
  {
    pattern: /^Yeni ([\d.,]+), güncellenen ([\d.,]+)(?: · Aralık (.+))?$/,
    replace: (match) => {
      const range = match[3]?.replace(/^(\d+) gün$/, "$1 days");
      return `New: ${match[1]}, updated: ${match[2]}${range ? ` · Range: ${range}` : ""}`;
    },
  },
  { pattern: /^([\d.,]+) sn$/, replace: (match) => `${match[1]} sec` },
  { pattern: /^(\d+) dk (\d+) sn$/, replace: (match) => `${match[1]} min ${match[2]} sec` },
  { pattern: /^Seçili takipleri senkronla \((\d+)\)$/, replace: (match) => `Sync selected tracking numbers (${match[1]})` },
  {
    pattern: /^DHL reports shipment activity \((.+)\)\. This label was already consumed in inventory, so only the carrier audit was updated\.$/,
    replace: (match) =>
      `DHL reports shipment activity (${match[1]}). This label was already consumed in inventory, so only the carrier audit was updated.`,
  },
  { pattern: /^(\d+) konu takip bekliyor\.$/, replace: (match) => `${match[1]} items are awaiting review.` },
  {
    pattern: /^Toplam: ([\d.,]+|\.{3}) · Kullanıldı: ([\d.,]+|\.{3}) · Void: ([\d.,]+|\.{3})$/,
    replace: (match) => `Total: ${match[1]} · Used: ${match[2]} · Void: ${match[3]}`,
  },
  {
    pattern: /^(\d+) DHL gönderisi izleniyor; (\d+) kayıt müdahale listesinde\.$/,
    replace: (match) => `${match[1]} DHL shipments monitored; ${match[2]} records need attention.`,
  },
  { pattern: /^(\d+) günlük DHL etiketi$/, replace: (match) => `DHL labels from the last ${match[1]} days` },
  { pattern: /^(\d+) gönderi$/, replace: (match) => `${match[1]} shipments` },
  { pattern: /^(\d+) günü aşan kayıt$/, replace: (match) => `Records older than ${match[1]} days` },
  { pattern: /^(\d+)\/(\d+) başarılı$/, replace: (match) => `${match[1]}/${match[2]} successful` },
  { pattern: /^Bugün ilgilenmen gereken (\d+) gönderi var$/, replace: (match) => `${match[1]} shipments need your attention today` },
  {
    pattern: /^(\d+) ilk scan almadı, (\d+) gönderi riskte\.$/,
    replace: (match) => `${match[1]} without a first scan; ${match[2]} shipments at risk.`,
  },
  { pattern: /^(\d+) gönderide exception sinyali var$/, replace: (match) => `${match[1]} shipments have an exception signal` },
  { pattern: /^(\d+) kayıt başarı dışında\.$/, replace: (match) => `${match[1]} records are not successful.` },
  {
    pattern: /^(\d+) çıkan · (\d+) sorun · (\d+) iade$/,
    replace: (match) => `${match[1]} shipped · ${match[2]} problematic · ${match[3]} returns`,
  },
  { pattern: /^(\d+) kayıt gösteriliyor\.$/, replace: (match) => `${match[1]} records shown.` },
  { pattern: /^(\d+)-(\d+) \/ ([\d.]+) kayıt$/, replace: (match) => `${match[1]}–${match[2]} of ${match[3]} records` },
  {
    pattern: /^([\d.]+) kayıt içinde (\d+)-(\d+) aralığı gösteriliyor\. (\d+) müsait etiket seçili\.$/,
    replace: (match) => `${match[2]}–${match[3]} of ${match[1]} records shown. ${match[4]} available labels selected.`,
  },
  {
    pattern: /^([\d.]+) kayıttan (\d+)-(\d+) gösteriliyor\.$/,
    replace: (match) => `${match[2]}–${match[3]} of ${match[1]} records shown.`,
  },
  {
    pattern: /^(.+?) hesabı için fatura, gönderici, güvenlik ve şifre ayarları\.$/,
    replace: (match) => `Invoice, sender, security and password settings for ${match[1]}.`,
  },
  {
    pattern: /^(\d+) gönderilik son toplu paketi tekrar indirebilirsiniz\.$/,
    replace: (match) => `You can download the latest bulk package containing ${match[1]} shipments again.`,
  },
  {
    pattern: /^(\d+) etiketi tek PDF olarak tekrar indirebilirsiniz\.$/,
    replace: (match) => `You can download the latest ${match[1]} labels again as one PDF file.`,
  },
  {
    pattern: /^(\d+) etiket tek PDF olarak indirildi\.$/,
    replace: (match) => `${match[1]} labels were downloaded as one PDF file.`,
  },
  {
    pattern: /^(\d+) etiket tek PDF dosyası olarak indirildi\.$/,
    replace: (match) => `${match[1]} labels were downloaded as one PDF file.`,
  },
  {
    pattern: /^(\d+) filtrelenmiş gönderinin tamamı seçildi\.$/,
    replace: (match) => `All ${match[1]} filtered shipments were selected.`,
  },
  {
    pattern: /^(\d+) indirilebilir aktif gönderi seçildi; (\d+) uygun olmayan kayıt atlandı\.$/,
    replace: (match) => `${match[1]} active shipments with downloadable labels were selected; ${match[2]} ineligible records were skipped.`,
  },
  {
    pattern: /^(\d+) filtrelenmiş sonuçtan tek PDF güvenlik sınırı olan ilk (\d+) indirilebilir gönderi seçildi\.$/,
    replace: (match) => `From ${match[1]} filtered results, the first ${match[2]} downloadable shipments were selected up to the single-PDF safety limit.`,
  },
  {
    pattern: /^Seçili tek PDF indir \((\d+)\)$/,
    replace: (match) => `Download selection as one PDF (${match[1]})`,
  },
  {
    pattern: /^Tek PDF hazırlanıyor \((\d+)\/(\d+)\)$/,
    replace: (match) => `Preparing one PDF (${match[1]}/${match[2]})`,
  },
  {
    pattern: /^(\d+) \/ (\d+) etiket PDF'e ekleniyor\. Sistem 50'şer adımlık güvenli parçalar halinde çalışıyor\.$/,
    replace: (match) => `${match[1]} / ${match[2]} labels are being added to the PDF. Processing runs internally in safe groups of 50.`,
  },
  {
    pattern: /^(\d+) \/ (\d+) sipariş güvenli gruplar halinde işleniyor\. Pencereyi kapatmayın\.$/,
    replace: (match) => `${match[1]} / ${match[2]} orders are being processed in safe groups. Do not close this window.`,
  },
  {
    pattern: /^(\d+) etiket oluşturuldu, (\d+) mevcut gönderi atlandı, (\d+) hata\.(?: (\d+) sipariş otomatik arşivlendi\.)?(?: (\d+) yarım kalmış etiket PDF'i otomatik tamamlandı\.)?(?: (\d+) etiket tek PDF olarak indirildi\.)?$/,
    replace: (match) =>
      `${match[1]} labels created, ${match[2]} existing shipments skipped, ${match[3]} errors.` +
      (match[4] ? ` ${match[4]} orders were archived automatically.` : "") +
      (match[5] ? ` ${match[5]} interrupted label PDFs were completed automatically.` : "") +
      (match[6] ? ` ${match[6]} labels were downloaded as one PDF file.` : ""),
  },
  {
    pattern: /^(\d+) etiket PDF'i henüz hazır olmadığı için eksik toplu PDF indirilmedi\. Son toplu işlemden yeniden deneyin\.$/,
    replace: (match) => `${match[1]} label PDFs are not ready yet, so an incomplete bulk PDF was not downloaded. Retry from the latest bulk operation.`,
  },
  {
    pattern: /^Tek PDF içinde en fazla (\d+) etiket indirilebilir\.$/,
    replace: (match) => `One PDF file can contain up to ${match[1]} labels.`,
  },
  { pattern: /^(\d+) sipariş seçildi$/, replace: (match) => `${match[1]} orders selected` },
  { pattern: /^(\d+) sipariş ana listeden kaldırılacak\.$/, replace: (match) => `${match[1]} orders will be removed from the main list.` },
  {
    pattern: /^(\d+) sipariş arşivlendi\.(?: (\d+) sipariş zaten arşivdeydi veya erişilebilir değildi\.)?$/,
    replace: (match) =>
      `${match[1]} orders archived.` +
      (match[2] ? ` ${match[2]} orders were already archived or inaccessible.` : ""),
  },
  {
    pattern: /^Tek toplu arşiv işleminde en fazla (\d+) sipariş seçilebilir\.$/,
    replace: (match) => `Up to ${match[1]} orders can be selected for one bulk archive operation.`,
  },
  {
    pattern: /^Güvenli işlem sınırı nedeniyle en fazla (\d+) sipariş seçildi\.$/,
    replace: (match) => `The safe operation limit selected at most ${match[1]} orders.`,
  },
  {
    pattern: /^(\d+) sipariş hazır\. En fazla (\d+) sipariş tek toplu işlemde sıraya alınır\.$/,
    replace: (match) => `${match[1]} orders ready. Up to ${match[2]} orders are queued per bulk operation.`,
  },
  {
    pattern: /^(\d+) etiket (\d+) PDF dosyası olarak indirildi\.$/,
    replace: (match) => `${match[1]} labels downloaded as ${match[2]} PDF files.`,
  },
  {
    pattern: /^(\d+) etiketi PDF dosyaları olarak tekrar indirebilirsiniz\.$/,
    replace: (match) => `You can download ${match[1]} labels again as PDF files.`,
  },
  { pattern: /^(\d+) adet\.$/, replace: (match) => `${match[1]} items.` },
  { pattern: /^(\d+) stok sınırını aşıyor\.$/, replace: (match) => `Exceeds the stock limit of ${match[1]}.` },
  { pattern: /^Seçili iptal \((\d+)\)$/, replace: (match) => `Cancel selected (${match[1]})` },
  { pattern: /^(\d+) teslim$/, replace: (match) => `${match[1]} delivered` },
  { pattern: /^(\d+) kargo$/, replace: (match) => `${match[1]} shipments` },
  { pattern: /^(.+?) · Tüm zamanlar: ([\d.,]+)$/, replace: (match) => `${match[1]} · All time: ${match[2]}` },
  { pattern: /^Tüm zamanlar: ([\d.,]+)$/, replace: (match) => `All time: ${match[1]}` },
  { pattern: /^(.+?) · printed$/, replace: (match) => `${match[1]} · Printed` },
  { pattern: /^(.+?) · shipped$/, replace: (match) => `${match[1]} · Shipped` },
  { pattern: /^(.+?) · open$/, replace: (match) => `${match[1]} · Open` },
  { pattern: /^(\d+) etiketi oluştur$/, replace: (match) => `Create ${match[1]} labels` },
  {
    pattern: /^(\d+) koli için (\d+) kredi gerekiyor; kullanılabilir kredi (\d+)\.$/,
    replace: (match) => `${match[2]} credits are required for ${match[1]} packages; ${match[3]} are available.`,
  },
];

export function translateCustomerEnglishText(value: string) {
  const normalized = value.replace(/\s+/g, " ").trim();
  const direct = customerEnglishTranslations[normalized];
  if (direct) return direct;
  for (const item of customerEnglishTranslationPatterns) {
    const match = normalized.match(item.pattern);
    if (match) return item.replace(match);
  }
  return null;
}
